/* Agiografia Icons — shared behaviour for ag-* sections.
   Plain JavaScript, no dependencies. Safe to include more than once. */
(function () {
  if (window.AGIOGRAFIA_LOADED) return;
  window.AGIOGRAFIA_LOADED = true;
  /* Translated strings come from snippets/ag-i18n.liquid (window.AgI18n); English is the fallback. */
  var tr = function (k, en) { return window.agT ? window.agT(k, en) : en; };

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || '€{{amount}}';
    function delimit(n, precision, thousands, decimal) {
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(precision);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return format;
    var value;
    switch (match[1]) {
      case 'amount_no_decimals': value = delimit(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, 2, "'", '.'); break;
      default: value = delimit(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------- Variant picker (product page + commission) ---------- */
  function initPicker(root) {
    var dataEl = root.querySelector('[data-ag-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var moneyFormat = root.getAttribute('data-money-format');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-ag-option]'));
    var idInput = root.querySelector('input[name="id"]');
    var submit = root.querySelector('[data-ag-submit]');
    var updateUrl = root.hasAttribute('data-ag-url');
    var current = variants.filter(function (v) { return String(v.id) === String(idInput && idInput.value); })[0] || variants[0];
    var selected = current ? current.options.slice() : [];

    function matches(v, sel, skip) {
      for (var i = 0; i < sel.length; i++) {
        if (i === skip) continue;
        if (v.options[i] !== sel[i]) return false;
      }
      return true;
    }
    function findVariant(sel) {
      return variants.filter(function (v) { return matches(v, sel, -1); })[0];
    }
    function resolve(changed) {
      if (findVariant(selected)) return;
      var best = null, bestScore = -1;
      variants.forEach(function (v) {
        if (v.options[changed] !== selected[changed]) return;
        var score = 0;
        for (var i = 0; i < selected.length; i++) if (v.options[i] === selected[i]) score++;
        if (score > bestScore) { best = v; bestScore = score; }
      });
      if (best) selected = best.options.slice();
    }
    function render() {
      var v = findVariant(selected);
      groups.forEach(function (g) {
        var idx = parseInt(g.getAttribute('data-ag-option'), 10);
        Array.prototype.forEach.call(g.querySelectorAll('[data-value]'), function (btn) {
          var val = btn.getAttribute('data-value');
          // A value is offered when some variant has it together with the choices made in the
          // earlier steps (later steps adapt automatically when this one changes).
          var possible = variants.some(function (x) {
            if (x.options[idx] !== val) return false;
            for (var k = 0; k < idx; k++) if (x.options[k] !== selected[k]) return false;
            return true;
          });
          btn.disabled = !possible;
          btn.setAttribute('aria-checked', val === selected[idx] ? 'true' : 'false');
          var priceEl = btn.querySelector('[data-ag-optprice]');
          if (priceEl) {
            var trial = selected.slice(); trial[idx] = val;
            var tv = findVariant(trial);
            priceEl.textContent = tv ? formatMoney(tv.price, moneyFormat) : '';
          }
        });
      });
      Array.prototype.forEach.call(root.querySelectorAll('[data-ag-selected]'), function (el) {
        var i = parseInt(el.getAttribute('data-ag-selected'), 10);
        var val = selected[i] || '';
        var shown = el.hasAttribute('data-ag-pretty') ? val.replace(/ x /g, ' \u00d7 ') : val;
        /* Inch countries: "7.9 × 13.8 in (20 × 35 cm)" instead of "20 × 35 cm (7.9 × 13.8 in)" */
        if (root.hasAttribute('data-ag-inch-first')) {
          var sw = shown.match(/^(.*?) \((.*\bin)\)$/);
          if (sw) shown = sw[2] + ' (' + sw[1] + ')';
        }
        el.textContent = shown;
      });
      if (!v) {
        if (submit) { submit.disabled = true; submit.querySelector('[data-ag-submit-text]').textContent = submit.getAttribute('data-text-unavailable'); }
        return;
      }
      if (idInput) idInput.value = v.id;
      Array.prototype.forEach.call(root.querySelectorAll('[data-ag-price]'), function (el) { el.textContent = formatMoney(v.price, moneyFormat); });
      Array.prototype.forEach.call(root.querySelectorAll('[data-ag-compare]'), function (el) {
        el.textContent = v.compare_at_price > v.price ? formatMoney(v.compare_at_price, moneyFormat) : '';
      });
      if (submit) {
        submit.disabled = !v.available;
        var t = submit.querySelector('[data-ag-submit-text]');
        if (t) t.textContent = v.available ? submit.getAttribute('data-text-add') : submit.getAttribute('data-text-sold');
      }
      if (updateUrl && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      if (v.featured_media_id) {
        var thumb = document.querySelector('[data-ag-thumb][data-media-id="' + v.featured_media_id + '"]');
        if (thumb) showThumb(thumb);
      }
      root.dispatchEvent(new CustomEvent('ag:variant', { bubbles: true, detail: { variant: v, selected: selected.slice() } }));
    }
    groups.forEach(function (g) {
      var idx = parseInt(g.getAttribute('data-ag-option'), 10);
      g.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-value]');
        if (!btn || btn.disabled) return;
        selected[idx] = btn.getAttribute('data-value');
        resolve(idx);
        render();
      });
    });
    render();
  }

  /* ---------- Finishing touches (4 Nov 2026): stand, gift bag, lettering, dedication ----------
     Each [data-ag-extra] box offers an add-on product (see the "Finishing touch" blocks in
     ag-main-product). Its chosen variant goes into the cart right after the icon (initAjaxForm).
     data-max-cm hides the box, or fades it with a note, when the chosen size is larger
     (largest side, in cm). The price shows icon + chosen extras, with a short breakdown. */
  function agSizeCm(card) {
    var on = card.querySelector('.ag-pw__sizes [aria-checked="true"]');
    if (!on) return 0;
    var txt = (on.getAttribute('data-value') || '').split('(')[0];
    var nums = (txt.match(/\d+(?:[.,]\d+)?/g) || []).map(function (n) { return parseFloat(n.replace(',', '.')); });
    return nums.length ? Math.max.apply(null, nums) : 0;
  }
  function extraText(box) {
    var wrap = box.querySelector('[data-ag-extra-text]');
    return wrap ? wrap.querySelector('input,textarea') : null;
  }
  /* The extra chosen in one box: { id, price, name, text, prop, box } or null */
  function extraChoice(box) {
    if (box.hidden || box.classList.contains('is-off')) return null;
    var check = box.querySelector('[data-ag-extra-check]');
    var pick = null;
    if (check) {
      if (check.checked && !check.disabled) pick = { id: check.value, price: parseInt(check.getAttribute('data-price'), 10) || 0, name: box.getAttribute('data-name') };
    } else {
      var on = box.querySelector('[data-ag-extra-value][aria-checked="true"]');
      if (on && on.getAttribute('data-ag-extra-value') && !on.disabled) {
        pick = { id: on.getAttribute('data-ag-extra-value'), price: parseInt(on.getAttribute('data-price'), 10) || 0, name: on.getAttribute('data-name') || box.getAttribute('data-name') };
      }
    }
    if (!pick) return null;
    /* Icon sets: one per icon, e.g. 3 stands for a set of 3 */
    pick.per = parseInt(box.getAttribute('data-per'), 10) || 1;
    pick.unit = pick.price;
    pick.price = pick.unit * pick.per;
    var field = extraText(box);
    if (field) {
      pick.text = (field.value || '').trim();
      pick.prop = field.closest('[data-ag-extra-text]').getAttribute('data-prop') || box.getAttribute('data-name');
    }
    pick.box = box;
    return pick;
  }
  function extrasIn(scope) {
    return Array.prototype.map.call(scope.querySelectorAll('[data-ag-extra]'), extraChoice).filter(Boolean);
  }
  function setExtra(box, btn) {
    Array.prototype.forEach.call(box.querySelectorAll('[data-ag-extra-value]'), function (b) { b.setAttribute('aria-checked', b === btn ? 'true' : 'false'); });
    var lab = box.querySelector('[data-ag-extra-label]');
    if (lab) lab.textContent = btn.getAttribute('data-text') || btn.textContent.trim();
    var wrap = box.querySelector('[data-ag-extra-text]');
    if (wrap) {
      var show = !!btn.getAttribute('data-ag-extra-value');
      wrap.hidden = !show;
      var f = extraText(box); if (f) f.disabled = !show;
      return show ? f : null;
    }
    return null;
  }
  function clearExtra(box) {
    var check = box.querySelector('[data-ag-extra-check]');
    if (check) { check.checked = false; return; }
    var none = box.querySelector('[data-ag-extra-value=""]');
    if (none) setExtra(box, none);
  }
  function updateExtras(card) {
    if (!card) return;
    var picks = extrasIn(card);
    var v = card.__agVariant;
    var fmt = card.getAttribute('data-money-format');
    var sum = card.querySelector('[data-ag-breakdown]');
    if (v) {
      var total = v.price + picks.reduce(function (a, p) { return a + p.price; }, 0);
      Array.prototype.forEach.call(card.querySelectorAll('[data-ag-price]'), function (el) { el.textContent = formatMoney(total, fmt); });
      if (sum) {
        if (picks.length) {
          var short = function (c) { return formatMoney(c, fmt).replace(/[.,]00(?=\D*$)/, ''); };
          sum.textContent = [tr('product.extras_icon', 'Icon') + ' ' + short(v.price)].concat(picks.map(function (p) { return p.name + ' ' + (p.per > 1 ? p.per + ' \u00d7 ' + short(p.unit) : short(p.price)); })).join(' \u00b7 ');
          sum.hidden = false;
        } else { sum.hidden = true; sum.textContent = ''; }
      }
    }
    var form = card.querySelector('form[data-ag-ajax]');
    if (form) updateAddonUI(form);
  }
  function initExtras(wrap) {
    if (wrap.__agExtras) return; wrap.__agExtras = true;
    var card = wrap.closest('[data-ag-picker]') || wrap.parentNode;
    var grey = wrap.getAttribute('data-limit-mode') === 'grey';
    var note = wrap.getAttribute('data-limit-note') || 'Available for icons up to [max] cm';
    var boxes = Array.prototype.slice.call(wrap.querySelectorAll('[data-ag-extra]'));
    function limits() {
      var cm = agSizeCm(card);
      boxes.forEach(function (box) {
        var max = parseFloat(box.getAttribute('data-max-cm')) || 0;
        var over = max > 0 && cm > max;
        var off = box.querySelector('[data-ag-extra-off]');
        if (over) clearExtra(box);
        if (grey) {
          box.hidden = false;
          box.classList.toggle('is-off', over);
          Array.prototype.forEach.call(box.querySelectorAll('[data-ag-extra-value]:not([data-ag-extra-value=""]),[data-ag-extra-check]'), function (el) {
            el.disabled = over || el.hasAttribute('data-sold');
          });
          if (off) { off.hidden = !over; off.textContent = over ? note.replace('[max]', max) : ''; }
        } else {
          box.hidden = over;
          box.classList.remove('is-off');
          if (off) off.hidden = true;
        }
      });
      wrap.hidden = boxes.every(function (b) { return b.hidden; });
      updateExtras(card);
    }
    card.addEventListener('ag:variant', function (e) {
      if (e.detail && e.detail.variant) card.__agVariant = e.detail.variant;
      setTimeout(limits, 0);
    });
    wrap.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ag-extra-value]');
      if (!btn || btn.disabled) return;
      var box = btn.closest('[data-ag-extra]');
      var field = setExtra(box, btn);
      if (field) field.focus();
      updateExtras(card);
    });
    wrap.addEventListener('change', function (e) {
      if (e.target.matches('[data-ag-extra-check]')) updateExtras(card);
    });
    wrap.addEventListener('input', function (e) {
      var f = e.target;
      if (!f.closest('[data-ag-extra-text]')) return;
      f.classList.remove('is-invalid');
      var er = card.querySelector('[data-ag-error]');
      if (er && !er.hidden) { er.hidden = true; er.textContent = ''; }
      var c = f.closest('[data-ag-extra-text]').querySelector('[data-ag-count]');
      if (c) c.textContent = f.value.length + ' / ' + c.getAttribute('data-max');
    });
    limits();
  }

  /* ---------- Search as you type ----------
     Any search box (the header panel, the search page) shows suggestions while typing.
     Results come from Shopify's predictive search, rendered by sections/ag-predictive-search. */
  function initSuggest(input) {
    if (input.__agSuggest || !input.form) return; input.__agSuggest = true;
    var form = input.form;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var box = document.createElement('div');
    box.className = 'ag-s ag-ps';
    box.id = 'AgSuggest-' + Math.random().toString(36).slice(2, 8);
    box.hidden = true;
    box.setAttribute('aria-label', tr('search.suggestions', 'Search suggestions'));
    form.parentNode.insertBefore(box, form.nextSibling);
    input.setAttribute('aria-controls', box.id);
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    var timer, ctrl, last = '';
    function close() { box.hidden = true; input.setAttribute('aria-expanded', 'false'); }
    function run() {
      var q = input.value.trim();
      if (q.length < 2) { close(); box.innerHTML = ''; last = ''; return; }
      if (q === last) { if (box.innerHTML) { box.hidden = false; input.setAttribute('aria-expanded', 'true'); } return; }
      last = q;
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      box.classList.add('is-loading');
      var url = root + 'search/suggest?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,page,article,query&resources[limit]=6&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last&resources[options][fields]=title,tag,product_type,variants.title' +
        '&section_id=ag-predictive-search';
      fetch(url, ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (input.value.trim() !== q) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var res = doc.getElementById('ag-ps');
          box.innerHTML = res ? res.outerHTML : '';
          box.hidden = !res;
          input.setAttribute('aria-expanded', res ? 'true' : 'false');
        })
        .catch(function () {})
        .then(function () { box.classList.remove('is-loading'); });
    }
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 180); });
    var quiet = false; // set when Escape closes the list, so refocusing the box does not reopen it
    input.addEventListener('focus', function () {
      if (quiet) { quiet = false; return; }
      if (box.innerHTML && input.value.trim().length >= 2) { box.hidden = false; input.setAttribute('aria-expanded', 'true'); }
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !box.hidden) { e.stopPropagation(); close(); }
      if (e.key === 'ArrowDown' && !box.hidden) { var first = box.querySelector('a'); if (first) { e.preventDefault(); first.focus(); } }
    });
    box.addEventListener('keydown', function (e) {
      var links = Array.prototype.slice.call(box.querySelectorAll('a'));
      var i = links.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (links[i + 1] || links[0]).focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); if (i <= 0) input.focus(); else links[i - 1].focus(); }
      else if (e.key === 'Escape') { e.stopPropagation(); close(); quiet = true; input.focus(); }
    });
    document.addEventListener('click', function (e) { if (!box.contains(e.target) && e.target !== input) close(); });
  }
  /* Header search panel */
  function closeSearchPanel(panel, refocus) {
    panel.hidden = true;
    var opener = document.querySelector('[data-ag-search-open][aria-controls="' + panel.id + '"]');
    if (opener) { opener.setAttribute('aria-expanded', 'false'); if (refocus) opener.focus(); }
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest && e.target.closest('[data-ag-search-open]');
    if (open) {
      var panel = document.getElementById(open.getAttribute('aria-controls'));
      if (!panel) return; // no panel: the link goes to the search page
      e.preventDefault();
      if (!panel.hidden) { closeSearchPanel(panel, false); return; }
      panel.hidden = false;
      open.setAttribute('aria-expanded', 'true');
      var field = panel.querySelector('input[type="search"]');
      if (field) setTimeout(function () { field.focus(); }, 30);
      return;
    }
    var shut = e.target.closest && e.target.closest('[data-ag-search-close]');
    if (shut) { closeSearchPanel(shut.closest('[data-ag-search-panel]'), true); return; }
    var panelOpen = document.querySelector('[data-ag-search-panel]:not([hidden])');
    if (panelOpen && !panelOpen.contains(e.target)) closeSearchPanel(panelOpen, false);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var panelOpen = document.querySelector('[data-ag-search-panel]:not([hidden])');
    if (panelOpen) closeSearchPanel(panelOpen, true);
  });
  /* Voice search: speaks into the search box (Web Speech API; hidden where unsupported).
     Add #voicetest to a page address to see the browser's exact reason when it refuses. */
  function initVoice(btn) {
    if (btn.__agVoice) return; btn.__agVoice = true;
    var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    var form = btn.closest('form');
    var input = form && form.querySelector('input[name="q"]');
    if (!SR || !input) return;
    // Browsers that expose voice input but never let a website use it: DuckDuckGo, and the in-app browsers of Facebook, Instagram, Messenger and others
    if (/Ddg\/|DuckDuckGo|FBAN|FBAV|FB_IAB|Instagram|Messenger|Line\/|Snapchat|Pinterest|TikTok|musical_ly/i.test(navigator.userAgent) && !/voicetest/i.test(location.hash + location.search)) return;
    btn.hidden = false;
    var LOCALES = { en: 'en-US', el: 'el-GR', de: 'de-DE', fr: 'fr-FR', it: 'it-IT', es: 'es-ES', ro: 'ro-RO', ru: 'ru-RU', bg: 'bg-BG', sr: 'sr-RS', uk: 'uk-UA', nl: 'nl-NL', pt: 'pt-PT', pl: 'pl-PL' };
    var rec = null, listening = false, failed = false, msgTimer = null, triedFallback = false;
    var label = btn.getAttribute('aria-label');
    var debug = /voicetest/i.test(location.hash + location.search);
    // A full language-region code (Safari is unreliable with a bare "en")
    function speechLang() {
      var set = (btn.getAttribute('data-lang') || '').trim();
      if (set) return set;
      var page = (document.documentElement.lang || '').toLowerCase();
      var base = page.split('-')[0] || 'en';
      var nav = navigator.language || '';
      if (nav.indexOf('-') > 0 && nav.toLowerCase().indexOf(base) === 0) return nav;
      if (page.indexOf('-') > 0) return page;
      return LOCALES[base] || 'en-US';
    }
    function restorePh() { input.placeholder = input.getAttribute('data-ph') || input.placeholder; }
    // A short note in the box that goes away by itself after a few seconds
    function note(msg, code) {
      clearTimeout(msgTimer);
      input.placeholder = debug && code ? msg + ' (' + code + ')' : msg;
      if (!debug) msgTimer = setTimeout(restorePh, 3500);
    }
    function stop() {
      listening = false;
      btn.classList.remove('is-listening');
      btn.setAttribute('aria-pressed', 'false');
      btn.setAttribute('aria-label', label);
      if (!failed) restorePh();
    }
    function listen(lang) {
      rec = new SR();
      rec.lang = lang;
      rec.interimResults = true;
      rec.maxAlternatives = 1;
      rec.continuous = false;
      rec.onresult = function (e) {
        var text = '';
        for (var i = 0; i < e.results.length; i++) text += e.results[i][0].transcript;
        input.value = text.replace(/[.?!]+$/, '').trim();
        input.dispatchEvent(new Event('input', { bubbles: true }));
      };
      rec.onerror = function (e) {
        var code = e.error || 'unknown';
        if (debug && window.console) console.warn('[AG voice] error:', code, 'lang:', lang, e.message || '');
        if (code === 'aborted') return;
        failed = true;
        stop();
        if (code === 'language-not-supported' && !triedFallback && lang !== 'en-US') {
          triedFallback = true; failed = false;
          try { listen('en-US'); } catch (err) {}
          return;
        }
        if (code === 'not-allowed') note(tr('search.mic_denied', 'Microphone not allowed'), code);
        else if (code === 'service-not-allowed') { note(tr('search.voice_unavailable', 'Voice search unavailable'), code); if (!debug) btn.hidden = true; }
        else if (code === 'audio-capture') note(tr('search.no_mic', 'No microphone found'), code);
        else if (code === 'no-speech') note('Didn’t catch that', code);
        else if (code === 'network') note(tr('search.no_connection', 'No connection, try again'), code);
        else note(tr('search.voice_unavailable', 'Voice search unavailable'), code);
      };
      rec.onend = function () { stop(); if (!failed) input.focus(); };
      failed = false;
      clearTimeout(msgTimer);
      if (!input.getAttribute('data-ph')) input.setAttribute('data-ph', input.placeholder);
      rec.start();
      listening = true;
      btn.classList.add('is-listening');
      btn.setAttribute('aria-pressed', 'true');
      btn.setAttribute('aria-label', 'Listening… tap to stop');
      input.value = '';
      input.placeholder = debug ? tr('search.listening', 'Listening…') + ' (' + lang + ')' : tr('search.listening', 'Listening…');
    }
    btn.addEventListener('click', function () {
      if (listening && rec) { rec.stop(); return; }
      triedFallback = false;
      try { listen(speechLang()); }
      catch (err) { failed = true; stop(); note(tr('search.voice_unavailable', 'Voice search unavailable'), err && err.name); }
    });
  }
  function suggestInputs(scope) {
    return (scope || document).querySelectorAll('input[data-ag-suggest], form[action$="/search"] input[name="q"]');
  }

  /* ---------- Sticky Add to cart (phones) ----------
     Shows while the product's own Add to cart button is off screen; tapping it presses that
     button, so apps and our cart logic run exactly as usual. */
  function initSticky(bar) {
    if (bar.__agSticky) return; bar.__agSticky = true;
    var card = bar.closest('[data-ag-picker]') || document;
    var real = card.querySelector('[data-ag-submit]');
    var btn = bar.querySelector('[data-ag-sticky-btn]');
    if (!real || !btn || !('IntersectionObserver' in window)) return;
    var mq = window.matchMedia('(max-width: 900px)');
    var offscreen = false;
    function sync() {
      btn.disabled = real.disabled;
      var t = real.querySelector('[data-ag-submit-text]');
      if (t) btn.textContent = t.textContent;
      var show = mq.matches && offscreen;
      bar.hidden = !show;
      document.body.classList.toggle('ag-sticky-on', show);
      document.documentElement.style.setProperty('--ag-dock', show ? Math.ceil(bar.getBoundingClientRect().height) + 'px' : '0px');
    }
    new IntersectionObserver(function (entries) {
      offscreen = !entries[0].isIntersecting;
      sync();
    }, { threshold: 0 }).observe(real);
    new MutationObserver(sync).observe(real, { attributes: true, childList: true, subtree: true, characterData: true });
    if (mq.addEventListener) mq.addEventListener('change', sync); else if (mq.addListener) mq.addListener(sync);
    btn.addEventListener('click', function () {
      if (real.disabled) return;
      real.click();
    });
  }

  /* ---------- Gallery ---------- */
  function showThumb(btn) {
    var gallery = btn.closest('[data-ag-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-ag-main]');
    var box = gallery.querySelector('[data-ag-mbox]');
    main.src = btn.getAttribute('data-src');
    main.srcset = btn.getAttribute('data-srcset') || '';
    main.alt = btn.getAttribute('data-alt') || '';
    box.classList.toggle('is-cover', btn.getAttribute('data-cover') === 'true');
    Array.prototype.forEach.call(gallery.querySelectorAll('[data-ag-thumb]'), function (t) { t.setAttribute('aria-current', t === btn ? 'true' : 'false'); });
  }
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-ag-thumb]');
    if (thumb) { showThumb(thumb); return; }
    var wall = e.target.closest('[data-ag-wall]');
    if (wall) {
      var w = document.querySelector('[data-ag-thumb][data-wall="true"]');
      if (w) { showThumb(w); w.closest('[data-ag-gallery]').scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      return;
    }
    var toggle = e.target.closest('[data-ag-filter-toggle]');
    if (toggle) {
      var panel = document.getElementById(toggle.getAttribute('aria-controls'));
      if (panel) {
        var open = panel.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      return;
    }
    var scrim = e.target.closest('[data-ag-close]');
    if (scrim) { var d = scrim.closest('details'); if (d) d.removeAttribute('open'); }
  });

  /* ---------- Collection filters: submit on change ---------- */
  function initFilters(form) {
    var timer;
    form.addEventListener('change', function () { form.submit(); });
    form.addEventListener('input', function (e) {
      if (e.target.type !== 'number') return;
      clearTimeout(timer);
      timer = setTimeout(function () { form.submit(); }, 900);
    });
  }

  /* ---------- Product recommendations ---------- */
  function initRecs(el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-ag-recs]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      else el.closest('section').hidden = true;
    }).catch(function () { el.closest('section').hidden = true; });
  }

  /* ---------- Icon pathways: every craft, companions and personal picks, loaded after the page ---------- */
  function initPaths(root) {
    if (root.getAttribute('data-ag-ready')) return;
    root.setAttribute('data-ag-ready', '1');
    var searchUrl = root.getAttribute('data-search-url') || '/search/suggest';
    var pillarKeys = { 'hand-painted-originals': 'hp', 'museum-editions': 'me', 'silver-reliefs': 'sr', 'gallery-prints': 'gp' };
    function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }
    function get(u) { return fetch(u).then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; }); }
    function suggest(q, section) {
      return get(searchUrl + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10&section_id=' + section);
    }
    function fill(key, out, minCards) {
      var slot = root.querySelector('[data-ag-slot="' + key + '"]');
      if (!slot || !out) return false;
      var count = out.querySelectorAll('.ag-ip__card').length;
      if (!count || count < (minCards || 1)) return false;
      var grid = slot.querySelector('[data-ag-fill]');
      if (grid) grid.innerHTML = out.innerHTML;
      var role = out.getAttribute('data-role');
      if (role) Array.prototype.forEach.call(slot.querySelectorAll('[data-ag-role-h]'), function (h) {
        h.hidden = h.getAttribute('data-ag-role-h') !== role;
      });
      var label = slot.querySelector('[data-ag-label]');
      if (label) label.textContent = label.getAttribute('data-ag-label').replace('[title]', out.getAttribute('data-title') || '');
      slot.hidden = false;
      var wrap = slot.closest('[data-ag-foryou]');
      if (wrap) wrap.hidden = false;
      return true;
    }

    // 1. The same icon in every craft
    var crafts = root.querySelector('[data-ag-slot="crafts"]');
    if (crafts) {
      suggest(crafts.getAttribute('data-q'), 'ag-same-icon').then(function (html) {
        if (!html) return;
        var out = parse(html).querySelector('[data-ag-out="crafts"]');
        if (!out) return;
        var current = crafts.getAttribute('data-current');
        Array.prototype.forEach.call(out.querySelectorAll('.ag-ip__card'), function (card) {
          var k = card.querySelector('.ag-ip__k');
          var key = pillarKeys[card.getAttribute('data-pillar')];
          if (k && key) k.textContent = crafts.getAttribute('data-label-' + key) || '';
          if (card.getAttribute('data-handle') === current) {
            card.classList.add('is-current');
            card.setAttribute('aria-current', 'page');
            if (k) k.textContent = crafts.getAttribute('data-viewing') || k.textContent;
          }
        });
        fill('crafts', out, 2);
      });
    }

    // 2 and 3. Companions and personal picks
    var url = root.getAttribute('data-url');
    if (!url) return;
    get(url).then(function (html) {
      if (!html) return;
      var doc = parse(html);
      ['pair', 'history', 'region'].forEach(function (k) { fill(k, doc.querySelector('[data-ag-out="' + k + '"]')); });
      var name = doc.querySelector('[data-ag-out="name"][data-term]');
      if (name && root.querySelector('[data-ag-slot="name"]')) {
        suggest(name.getAttribute('data-term'), 'ag-name-saint').then(function (h2) {
          if (h2) fill('name', parse(h2).querySelector('[data-ag-out="name"]'));
        });
      }
    });
  }

  /* ---------- Judge.me review list: short preview with "Show all reviews" ---------- */
  function initJmClamp(cfg) {
    if (cfg.getAttribute('data-ag-ready')) return;
    cfg.setAttribute('data-ag-ready', '1');
    var sec = document.querySelector('[id$="__judgeme"]');
    if (!sec) return;
    var h = parseInt(cfg.getAttribute('data-height'), 10) || 680;
    var more = cfg.getAttribute('data-more') || 'Show all reviews';
    var less = cfg.getAttribute('data-less') || 'Show fewer reviews';
    sec.classList.add('ag-jm-clamp');
    sec.style.setProperty('--ag-jm-h', h + 'px');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ag-jm-more';
    btn.textContent = more;
    btn.setAttribute('aria-expanded', 'false');
    var holder = sec.querySelector('.shopify-app-block') || sec.firstElementChild || sec;
    holder.parentNode.insertBefore(btn, holder.nextSibling);
    function widget() { return sec.querySelector('.jdgm-review-widget'); }
    function measure() {
      var w = widget();
      if (!w || sec.classList.contains('is-open')) return;
      sec.classList.toggle('is-short', w.scrollHeight <= h + 60);
    }
    function open(state) {
      sec.classList.toggle('is-open', state);
      btn.textContent = state ? less : more;
      btn.setAttribute('aria-expanded', state ? 'true' : 'false');
      if (!state) { measure(); sec.scrollIntoView({ block: 'start' }); }
    }
    btn.addEventListener('click', function () { open(!sec.classList.contains('is-open')); });
    // Links that jump to the reviews open the full list
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href="#judgeme_product_reviews"]');
      if (a) open(true);
    });
    if (window.ResizeObserver) {
      new ResizeObserver(measure).observe(sec);
    } else {
      setTimeout(measure, 1500);
    }
    measure();
  }

  /* ---------- Saints A–Z ---------- */
  // Strips one or more leading honorifics ("Saint Apostle Andrew" → "Andrew", label "Apostle").
  var PREFIX = /^(?:(saints?|st\.?|elder|prophetess|prophet|righteous|apostles?|archangel|holy)\s+)+/i;
  function normalize(s) { return s.normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function fetchCollection(handle, page, acc) {
    return fetch('/collections/' + handle + '/products.json?limit=250&page=' + page)
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (data) {
        var list = (data && data.products) || [];
        list.forEach(function (p) { acc.push(p.title); });
        if (list.length === 250 && page < 8) return fetchCollection(handle, page + 1, acc);
        return acc;
      });
  }
  function initSaints(root) {
    if (root.getAttribute('data-ag-ready')) return;
    root.setAttribute('data-ag-ready', '1');
    var handles = (root.getAttribute('data-collections') || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean);
    var list = root.querySelector('[data-ag-saint-list]');
    var bar = root.querySelector('[data-ag-az]');
    var input = document.getElementById(root.getAttribute('data-input'));
    var empty = root.querySelector('[data-ag-empty]');
    var searchUrl = root.getAttribute('data-search-url') || '/search';
    var entries = null;
    var MAX = 8;

    // Results panel right under the search box, so matches show where the visitor is typing
    var box = input ? (input.closest('.ag-search') || input.parentElement) : null;
    var res = null;
    if (box) {
      res = document.createElement('div');
      res.className = 'ag-sres';
      res.setAttribute('role', 'region');
      res.setAttribute('aria-live', 'polite');
      res.hidden = true;
      box.appendChild(res);
    }
    function link(e) {
      var a = document.createElement('a');
      a.href = searchUrl + '?type=product&q=' + encodeURIComponent(e.title);
      a.setAttribute('data-key', e.key);
      a.appendChild(document.createTextNode(e.name + ' '));
      var s = document.createElement('span');
      s.textContent = '· ' + e.label;
      a.appendChild(s);
      return a;
    }
    function query() {
      return normalize(input.value).toLowerCase().replace(PREFIX, '').replace(/\s+/g, ' ').trim();
    }
    function hit(e, q) { return !q || e.key.indexOf(q) !== -1 || e.full.indexOf(q) !== -1; }

    function filterList(q) {
      var any = false;
      Array.prototype.forEach.call(list.querySelectorAll('.ag-lt'), function (row) {
        var visible = 0;
        Array.prototype.forEach.call(row.querySelectorAll('a'), function (a) {
          var e = a._agEntry;
          var ok = e ? hit(e, q) : true;
          a.hidden = !ok;
          if (ok) visible++;
        });
        row.hidden = visible === 0;
        if (visible) any = true;
      });
      if (empty) empty.hidden = any;
    }
    function renderPanel(q) {
      if (!res) return;
      res.innerHTML = '';
      if (!q) { res.hidden = true; return; }
      if (!entries) {
        var wait = document.createElement('p');
        wait.className = 'ag-sres__note';
        wait.textContent = tr('saints.loading', 'Loading the saints…');
        res.appendChild(wait);
        res.hidden = false;
        return;
      }
      var found = entries.filter(function (e) { return hit(e, q); });
      found.sort(function (a, b) {
        var sa = a.key.indexOf(q) === 0 ? 0 : 1, sb = b.key.indexOf(q) === 0 ? 0 : 1;
        return sa - sb || a.key.localeCompare(b.key);
      });
      if (!found.length) {
        var none = document.createElement('p');
        none.className = 'ag-sres__note';
        none.appendChild(document.createTextNode('No saint matches “' + input.value.trim() + '”. '));
        var all = document.createElement('a');
        all.href = searchUrl + '?q=' + encodeURIComponent(input.value.trim());
        all.textContent = 'Search the whole gallery →';
        none.appendChild(all);
        res.appendChild(none);
      } else {
        var ul = document.createElement('div');
        ul.className = 'ag-sres__list';
        found.slice(0, MAX).forEach(function (e) { ul.appendChild(link(e)); });
        res.appendChild(ul);
        if (found.length > MAX) {
          var more = document.createElement('a');
          more.className = 'ag-sres__more';
          more.href = '#ag-saints-az';
          more.textContent = 'See all ' + found.length + ' matches in the A–Z list ↓';
          more.addEventListener('click', function (ev) {
            ev.preventDefault();
            res.hidden = true;
            root.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
          res.appendChild(more);
        }
      }
      res.hidden = false;
    }
    function update() {
      var q = query();
      if (entries) filterList(q);
      renderPanel(q);
    }

    if (input) {
      input.addEventListener('input', update);
      input.addEventListener('focus', function () { if (input.value.trim()) update(); });
      input.addEventListener('keydown', function (ev) {
        if (ev.key === 'Escape') { if (res) res.hidden = true; return; }
        if (ev.key !== 'Enter') return;
        ev.preventDefault();
        var first = res && !res.hidden ? res.querySelector('.ag-sres__list a') : null;
        var count = res ? res.querySelectorAll('.ag-sres__list a').length : 0;
        if (first && count === 1) { window.location.href = first.href; return; }
        if (first) { first.focus(); return; }
        if (input.value.trim()) window.location.href = searchUrl + '?q=' + encodeURIComponent(input.value.trim());
      });
      document.addEventListener('click', function (ev) {
        if (res && !res.hidden && box && !box.contains(ev.target)) res.hidden = true;
      });
    }
    root.id = root.id || 'ag-saints-az';

    Promise.all(handles.map(function (h) { return fetchCollection(h, 1, []); })).then(function (all) {
      var seen = {};
      entries = [];
      [].concat.apply([], all).forEach(function (title) {
        var m = title.match(PREFIX);
        if (!m) return;
        var name = title.slice(m[0].length).trim();
        var label = m[1].replace(/^st\.?$/i, 'Saint');
        label = label.charAt(0).toUpperCase() + label.slice(1).toLowerCase();
        var key = normalize(name).toLowerCase();
        if (!name || seen[key]) return;
        seen[key] = true;
        entries.push({ name: name, label: label, title: title, key: key, full: normalize(title).toLowerCase() });
      });
      entries.sort(function (a, b) { return a.key.localeCompare(b.key); });
      var groups = {};
      entries.forEach(function (e) {
        var letter = normalize(e.name).charAt(0).toUpperCase();
        if (!/[A-Z]/.test(letter)) letter = '#';
        (groups[letter] = groups[letter] || []).push(e);
      });
      list.innerHTML = '';
      bar.innerHTML = '';
      'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').forEach(function (L) {
        var node;
        if (groups[L]) { node = document.createElement('a'); node.href = '#ag-letter-' + L; }
        else { node = document.createElement('span'); node.setAttribute('aria-hidden', 'true'); }
        node.textContent = L;
        bar.appendChild(node);
      });
      Object.keys(groups).sort().forEach(function (L) {
        var row = document.createElement('div');
        row.className = 'ag-lt';
        row.id = 'ag-letter-' + L;
        row.setAttribute('data-letter', L);
        var big = document.createElement('span');
        big.className = 'ag-ltr';
        big.textContent = L;
        var names = document.createElement('div');
        names.className = 'ag-names';
        groups[L].forEach(function (e) {
          var a = link(e);
          a._agEntry = e;
          names.appendChild(a);
        });
        row.appendChild(big);
        row.appendChild(names);
        list.appendChild(row);
      });
      if (input && input.value.trim()) update();
    });
  }


  /* ---------- Highlights scroller (prev / next buttons) ---------- */
  function initScroller(root) {
    if (root.getAttribute('data-ag-ready')) return;
    root.setAttribute('data-ag-ready', '1');
    var track = root.querySelector('[data-ag-track]');
    var prev = root.querySelector('[data-ag-prev]');
    var next = root.querySelector('[data-ag-next]');
    if (!track) return;
    function step() {
      var item = track.querySelector('li');
      return item ? (item.getBoundingClientRect().width + 40) * 2 : 600;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Feast of the day ----------
     Items carry data-feast="October 9" (from custom.feast_day). Shows one work per
     saint whose feast is today; when none, the next feasts of the month. */
  function initFeast(root) {
    if (root.getAttribute('data-ag-ready')) return;
    root.setAttribute('data-ag-ready', '1');
    var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    var now = new Date();
    var month = MONTHS[now.getMonth()];
    var today = now.getDate();
    var show = parseInt(root.getAttribute('data-show'), 10) || 4;
    var list = root.querySelector('[data-ag-feast-list]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-feast]'));
    if (!list || !items.length) return;
    var dayEl = root.querySelector('[data-ag-feast-day]');
    var monEl = root.querySelector('[data-ag-feast-month]');
    var heading = root.querySelector('[data-ag-feast-heading]');
    var namesEl = root.querySelector('[data-ag-feast-names]');
    if (dayEl) dayEl.textContent = today;
    if (monEl) monEl.textContent = ((window.AgI18n || {}).months_of || [])[now.getMonth()] || month; /* month (English) is still used to match data-feast */

    var localMonth = ((window.AgI18n || {}).months_of || [])[now.getMonth()] || '';
    function dayOf(el) {
      var f = el.getAttribute('data-feast') || '';
      var m = f.match(new RegExp('^' + month + '\\s+(\\d{1,2})(?!\\d)', 'i'));
      /* Translated feast days: "9 octobre", "9. Oktober", "9 de octubre", "9 октября", "9 Οκτωβρίου", "9 października" */
      if (!m && localMonth && localMonth !== month) {
        try { m = f.match(new RegExp('^(\\d{1,2})(?:er|º|\\.)?\\s+(?:de\\s+)?' + localMonth + '(?![\\p{L}])', 'iu')); } catch (e) { m = null; }
      }
      return m ? parseInt(m[1], 10) : null;
    }
    var seen = {};
    var todays = [];
    var upcoming = [];
    items.forEach(function (el) {
      var d = dayOf(el);
      var title = el.getAttribute('data-title');
      if (d === null || seen[title]) return;
      if (d === today) { seen[title] = 1; todays.push(el); }
    });
    items.forEach(function (el) {
      var d = dayOf(el);
      var title = el.getAttribute('data-title');
      if (d === null || d <= today || seen[title]) return;
      seen[title] = 1;
      upcoming.push({ el: el, d: d });
    });
    upcoming.sort(function (a, b) { return a.d - b.d; });
    var chosen = todays.slice(0, show);
    upcoming.forEach(function (u) { if (chosen.length < show) chosen.push(u.el); });
    if (!chosen.length) return; /* keep the server-rendered selection */

    items.forEach(function (el) { el.hidden = true; el.classList.remove('is-today'); });
    chosen.forEach(function (el) {
      el.hidden = false;
      list.appendChild(el);
      if (todays.indexOf(el) !== -1) {
        el.classList.add('is-today');
        var tag = el.querySelector('[data-ag-feast-tag]');
        if (tag) tag.textContent = tr('feast.today', 'Today');
      }
    });
    list.setAttribute('data-count', String(Math.min(chosen.length, 4)));
    if (heading) heading.textContent = todays.length ? heading.getAttribute('data-today') : heading.getAttribute('data-next');
    if (namesEl) {
      var names = (todays.length ? todays : chosen.slice(0, 2)).map(function (el) { return el.getAttribute('data-title'); });
      namesEl.textContent = names.join(' · ');
    }
  }


  /* ---------- Opening slideshow (rooms) ---------- */
  function initOpening(root) {
    if (root.getAttribute('data-ag-ready')) return;
    root.setAttribute('data-ag-ready', '1');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ag-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ag-dot]'));
    var pause = root.querySelector('[data-ag-pause]');
    if (slides.length < 2) return;
    var i = 0;
    var timer = null;
    var ms = (parseInt(root.getAttribute('data-interval'), 10) || 7) * 1000;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
      dots.forEach(function (d, k) {
        d.classList.toggle('is-on', k === i);
        if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }
    function start() { stop(); timer = setInterval(function () { show(i + 1); }, ms); if (pause) { pause.textContent = 'II'; pause.setAttribute('aria-label', tr('opening.pause', 'Pause slideshow')); } }
    function stop() { if (timer) clearInterval(timer); timer = null; if (pause) { pause.textContent = '\u25B6'; pause.setAttribute('aria-label', tr('opening.play', 'Play slideshow')); } }
    dots.forEach(function (d) { d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-ag-dot'), 10)); if (timer) start(); }); });
    if (pause) pause.addEventListener('click', function () { if (timer) stop(); else start(); });
    if (!reduce) start(); else stop();
  }


  /* ---------- Salon wall: hang a different selection on each visit ---------- */
  function initShuffle(wall) {
    if (wall.getAttribute('data-ag-ready')) return;
    wall.setAttribute('data-ag-ready', '1');
    var items = Array.prototype.slice.call(wall.children);
    if (items.length < 2) return;
    for (var i = items.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = items[i]; items[i] = items[j]; items[j] = t;
    }
    items.forEach(function (el, k) {
      if (k < 14) Array.prototype.forEach.call(el.querySelectorAll('img'), function (im) { im.loading = 'eager'; });
      wall.appendChild(el);
    });
  }


  /* ---------- Salon wall: a curated, symmetrical hang composed on each visit ----------
     Every candidate carries data-fam (gold, hand, silver, blue, relief), data-dep
     (scene, standing, bust) and data-ori (portrait, landscape). The script measures
     each cut-out's real panel edges from its transparent PNG, then composes:
       centre      a large feast or scene icon (a landscape feast may hang above it)
       inner pair  two standing figures, two scenes, or two stacked pairs of busts
       outer pair  stacks of two or three smaller icons
     Mirrored positions always hold a matched pair (same technique and type),
     columns share one eye line, and gaps are equal. */
  var HANG_KEY = 'agHangBoxes.v1';
  function hangCache(write) {
    try {
      if (write) { localStorage.setItem(HANG_KEY, JSON.stringify(write)); return write; }
      return JSON.parse(localStorage.getItem(HANG_KEY) || '{}');
    } catch (e) { return write || {}; }
  }
  function measureCutout(src) {
    return new Promise(function (resolve) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          var w = im.naturalWidth, h = im.naturalHeight;
          var c = document.createElement('canvas'); c.width = w; c.height = h;
          var x = c.getContext('2d'); x.drawImage(im, 0, 0);
          var d = x.getImageData(0, 0, w, h).data;
          var rows = new Array(h).fill(0), cols = new Array(w).fill(0);
          for (var yy = 0; yy < h; yy++) for (var xx = 0; xx < w; xx++) {
            if (d[(yy * w + xx) * 4 + 3] > 200) { rows[yy]++; cols[xx]++; }
          }
          var minR = w * 0.15, minC = h * 0.15;
          var top = rows.findIndex(function (v) { return v > minR; });
          var bottom = h - 1 - rows.slice().reverse().findIndex(function (v) { return v > minR; });
          var left = cols.findIndex(function (v) { return v > minC; });
          var right = w - 1 - cols.slice().reverse().findIndex(function (v) { return v > minC; });
          if (top < 0 || left < 0 || bottom <= top || right <= left) return resolve(null);
          resolve({ x: left / w, y: top / h, w: (right - left + 1) / w, h: (bottom - top + 1) / h, a: ((right - left + 1) / w * w) / ((bottom - top + 1) / h * h) });
        } catch (e) { resolve(null); }
      };
      im.onerror = function () { resolve(null); };
      im.src = src;
    });
  }
  function shuffled(a) {
    a = a.slice();
    for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; }
    return a;
  }
  function composeHang(pool, compact) {
    var used = {};
    function free(fn) { return pool.filter(function (p) { return !used[p.title] && fn(p); }); }
    function take(p) { used[p.title] = 1; return p; }
    function one(fn) { var c = shuffled(free(fn)); return c.length ? take(c[0]) : null; }
    function pair(fn) {
      var groups = {};
      free(fn).forEach(function (p) { (groups[p.fam] = groups[p.fam] || []).push(p); });
      var fams = shuffled(Object.keys(groups).filter(function (f) { return groups[f].length >= 2; }));
      if (!fams.length) return null;
      var g = shuffled(groups[fams[0]]);
      return [take(g[0]), take(g[1])];
    }
    var portrait = function (p) { return p.ori !== 'landscape' && p.box.a < 1; };
    var scene = function (p) { return portrait(p) && p.dep === 'scene'; };
    var standing = function (p) { return portrait(p) && p.dep === 'standing'; };
    var bust = function (p) { return portrait(p) && p.dep === 'bust'; };
    var small = function (p) { return portrait(p) && p.dep !== 'scene'; };

    /* centre */
    var anchor = Math.random() < 0.35 ? one(function (p) { return scene(p) && p.fam === 'hand'; }) : null;
    anchor = anchor || one(scene) || one(portrait);
    if (!anchor) return null;
    var center = [{ p: anchor, h: 1 }];
    if (!compact && Math.random() < 0.35) {
      var lintel = one(function (p) { return p.ori === 'landscape' || p.box.a > 1.15; });
      if (lintel) center.unshift({ p: lintel, h: 0.34 });
    }
    var L = [], R = [];
    function addPair(pr, h, side) { if (!pr) return false; L.push({ p: pr[0], h: h }); R.push({ p: pr[1], h: h }); return true; }

    if (compact) {
      var colL = [], colR = [], pr, pr2;
      if (Math.random() < 0.4 && (pr = pair(standing))) {
        colL.push({ p: pr[0], h: 0.84 }); colR.push({ p: pr[1], h: 0.84 });
      } else if ((pr = pair(bust) || pair(small))) {
        pr2 = pair(bust) || pair(small);
        var hh = pr2 ? 0.46 : 0.6;
        colL.push({ p: pr[0], h: hh }); colR.push({ p: pr[1], h: hh });
        if (pr2) { colL.push({ p: pr2[0], h: hh }); colR.push({ p: pr2[1], h: hh }); }
      } else return { cols: [center] };
      return { cols: [colL, center, colR] };
    }

    /* inner pair */
    var innerL = [], innerR = [];
    var options = shuffled(['standing', 'scenes', 'busts']);
    for (var i = 0; i < options.length && !innerL.length; i++) {
      var o = options[i], a1, a2;
      if (o === 'standing' && (a1 = pair(standing))) { innerL.push({ p: a1[0], h: 0.86 }); innerR.push({ p: a1[1], h: 0.86 }); }
      else if (o === 'scenes' && (a1 = pair(scene))) { innerL.push({ p: a1[0], h: 0.64 }); innerR.push({ p: a1[1], h: 0.64 }); }
      else if (o === 'busts' && (a1 = pair(bust))) {
        a2 = pair(bust);
        innerL.push({ p: a1[0], h: 0.46 }); innerR.push({ p: a1[1], h: 0.46 });
        if (a2) { innerL.push({ p: a2[0], h: 0.46 }); innerR.push({ p: a2[1], h: 0.46 }); }
      }
    }
    /* outer pair: stacks of three, else two */
    var outerL = [], outerR = [];
    var k = Math.random() < 0.5 ? 3 : 2;
    var hk = k === 3 ? 0.3 : 0.42;
    for (var n = 0; n < k; n++) {
      var q = pair(bust) || pair(small);
      if (!q) break;
      outerL.push({ p: q[0], h: hk }); outerR.push({ p: q[1], h: hk });
    }
    if (outerL.length === 1) { outerL[0].h = 0.42; outerR[0].h = 0.42; }
    var cols = [];
    if (outerL.length) cols.push(outerL);
    if (innerL.length) cols.push(innerL);
    cols.push(center);
    if (innerR.length) cols.push(innerR);
    if (outerR.length) cols.push(outerR);
    return { cols: cols };
  }
  function placeHang(wall, plan, items) {
    var rect = wall.getBoundingClientRect();
    var W = rect.width, H = rect.height;
    if (!W || !H) return;
    var gap = 0.065, colGap = 0.085;
    var cols = plan.cols.map(function (col) {
      var w = 0, h = 0;
      col.forEach(function (it, i) { it.w = it.h * it.p.box.a; w = Math.max(w, it.w); h += it.h + (i ? gap : 0); });
      return { items: col, w: w, h: h };
    });
    var totalW = cols.reduce(function (s, c, i) { return s + c.w + (i ? colGap : 0); }, 0);
    var totalH = Math.max.apply(null, cols.map(function (c) { return c.h; }));
    var scale = Math.min(W / totalW, H / totalH) * 0.98;
    var x = (W - totalW * scale) / 2;
    var on = {};
    var order = 0;
    cols.forEach(function (c, ci) {
      var y = (H - c.h * scale) / 2;
      c.items.forEach(function (it) {
        var el = it.p.el, b = it.p.box;
        var w = it.w * scale, h = it.h * scale;
        var left = x + (c.w * scale - w) / 2;
        on[it.p.title] = 1;
        el.style.left = left + 'px'; el.style.top = y + 'px'; el.style.width = w + 'px'; el.style.height = h + 'px';
        el.style.transitionDelay = (order++ * 45) + 'ms';
        var img = el.querySelector('img[data-hung]');
        if (!img) {
          Array.prototype.forEach.call(el.querySelectorAll('img'), function (o) { o.remove(); });
          img = document.createElement('img');
          img.setAttribute('data-hung', '');
          img.alt = '';
          img.decoding = 'async';
          img.src = el.getAttribute('data-full');
          el.appendChild(img);
        }
        var iw = w / b.w, ih = h / b.h;
        img.style.width = iw + 'px'; img.style.height = ih + 'px';
        img.style.left = (-b.x * iw) + 'px'; img.style.top = (-b.y * ih) + 'px';
        el.classList.add('is-on');
        y += h + gap * scale;
      });
      x += (c.w + colGap) * scale;
    });
    items.forEach(function (p) { if (!on[p.title]) p.el.classList.remove('is-on'); });
  }
  function initHang(wall) {
    if (wall.getAttribute('data-ag-ready')) return;
    wall.setAttribute('data-ag-ready', '1');
    var els = Array.prototype.slice.call(wall.querySelectorAll('[data-thumb]'));
    function reveal() { wall.classList.remove('ag-op__wall--pending'); }
    if (els.length < 3) { reveal(); return; }
    var cache = hangCache();
    var timer = setTimeout(reveal, 4000);
    Promise.all(els.map(function (el) {
      var src = el.getAttribute('data-thumb');
      var key = src.split('?')[0];
      if (cache[key]) return Promise.resolve(cache[key]);
      return measureCutout(src).then(function (b) { if (b) cache[key] = b; return b; });
    })).then(function (boxes) {
      hangCache(cache);
      var seen = {};
      var items = [];
      els.forEach(function (el, i) {
        var b = boxes[i], t = el.getAttribute('data-title');
        if (!b || b.a < 0.35 || b.a > 2.6 || seen[t]) { el.classList.remove('is-on'); return; }
        seen[t] = 1;
        items.push({ el: el, title: t, fam: el.getAttribute('data-fam'), dep: el.getAttribute('data-dep'), ori: el.getAttribute('data-ori'), box: b });
      });
      if (items.length < 3) { clearTimeout(timer); reveal(); return; }
      var mq = window.matchMedia('(max-width: 900px)');
      var plans = {};
      function draw() {
        var compact = mq.matches;
        var key = compact ? 'c' : 'f';
        if (!plans[key]) plans[key] = composeHang(items, compact);
        if (!plans[key]) return;
        wall.classList.add('is-hung');
        placeHang(wall, plans[key], items);
      }
      draw();
      clearTimeout(timer);
      requestAnimationFrame(function () { wall.classList.add('is-shown'); reveal(); });
      var t2;
      window.addEventListener('resize', function () { clearTimeout(t2); t2 = setTimeout(draw, 150); });
    });
  }


  /* ---------- Cart: Symmetry's drawer ----------
     Symmetry (the host theme) renders its cart drawer as <cart-drawer class="js-cart-drawer">.
     These helpers refresh and open it; without a drawer they fall back to the cart page. */
  function cartDrawer() {
    var d = document.querySelector('.js-cart-drawer');
    return d && typeof d.open === 'function' ? d : null;
  }
  function setCartCount(n) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ag-cart-count]'), function (el) {
      el.textContent = n; el.hidden = !n;
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-ag-cart]'), function (el) {
      el.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
    });
  }
  function refreshCart() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCartCount(c.item_count); return c; })
      .catch(function () {});
  }
  function openCart(opener) {
    var d = cartDrawer();
    if (!d) { window.location.href = ((window.theme && window.theme.routes && window.theme.routes.cart) || '/cart'); return; }
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
    d.open(opener || null);
  }
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-ag-cart]');
    if (link && cartDrawer() && !(window.theme && window.theme.settings && window.theme.settings.cartType === 'page')) {
      e.preventDefault(); openCart(link);
    }
  });
  /* Symmetry announces cart changes made in its drawer; keep our header count in step. */
  ['on:cart:change', 'on:cart:add', 'on:line-item:change'].forEach(function (ev) {
    document.addEventListener(ev, function () { refreshCart(); });
  });

  /* ---------- Paid choice (e.g. custom lettering) ----------
     A choice button may carry data-ag-addon="<variant id>", and Finishing touch boxes offer
     add-ons too. Chosen add-ons are added to the cart right after the icon, with the same quantity. Both lines share
     a hidden reference (_ag_ref on the icon, _ag_for on the add-on) so the cart can keep them
     in step: same quantity, and the add-on leaves when its icon is removed. */
  function addonChip(form) {
    return form.querySelector('[data-ag-choice] [aria-checked="true"][data-ag-addon]');
  }
  function updateAddonUI(form) {
    if (!form) return;
    var paid = !!addonChip(form) || extrasIn(form).length > 0;
    var dyn = form.querySelector('.ag-pw__dyn');
    if (dyn) {
      dyn.hidden = paid; // "Buy it now" skips the cart, so it would leave the add-on out
      var btns = dyn.closest('.ag-pw__btns');
      if (btns) btns.classList.toggle('ag-pw__btns--one', paid || btns.hasAttribute('data-ag-one'));
    }
  }
  var AG_FLAG = 'agPaidChoice';
  function flag(v) { try { if (v) localStorage.setItem(AG_FLAG, '1'); else localStorage.removeItem(AG_FLAG); } catch (e) {} }
  function flagged() { try { return localStorage.getItem(AG_FLAG) === '1'; } catch (e) { return true; } }
  var syncing = false;
  function syncPaidChoices(force) {
    if (syncing || (!force && !flagged())) return Promise.resolve(false);
    syncing = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var parents = {}, changes = [], any = false;
        cart.items.forEach(function (it) { var p = it.properties || {}; if (p._ag_ref) parents[p._ag_ref] = (parents[p._ag_ref] || 0) + it.quantity; });
        cart.items.forEach(function (it) {
          var p = it.properties || {};
          if (!p._ag_for) return;
          any = true;
          var want = (parents[p._ag_for] || 0) * (parseInt(p._ag_per, 10) || 1);
          if (it.quantity !== want) changes.push({ id: it.key, quantity: want });
        });
        if (!any) flag(false);
        return changes.reduce(function (chain, c) {
          return chain.then(function () {
            return fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(c) });
          });
        }, Promise.resolve()).then(function () { return changes.length > 0; });
      })
      .then(function (changed) {
        syncing = false;
        if (changed) {
          refreshCart();
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
          if (/\/cart\/?$/.test(window.location.pathname)) window.location.reload();
        }
        return changed;
      })
      .catch(function () { syncing = false; return false; });
  }
  ['on:cart:change', 'on:line-item:change'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(function () { syncPaidChoices(false); }, 300); });
  });

  function initAjaxForm(form) {
    if (form.__agAjax) return; form.__agAjax = true;
    var btnsBox = form.querySelector('.ag-pw__btns');
    if (btnsBox && btnsBox.classList.contains('ag-pw__btns--one')) btnsBox.setAttribute('data-ag-one', '');
    updateAddonUI(form);
    form.addEventListener('submit', function (e) {
      var after = window.theme && window.theme.settings && window.theme.settings.afterAddToCart;
      var chip = addonChip(form);
      var extras = extrasIn(form);
      if (chip) extras.push({ id: chip.getAttribute('data-ag-addon') });
      var refInput = form.querySelector('input[name="properties[_ag_ref]"]');
      if (refInput) refInput.parentNode.removeChild(refInput);
      var err = form.querySelector('[data-ag-error]');
      /* A chosen extra that needs words (lettering, dedication) must have them */
      var missing = extras.filter(function (x) { return x.box && x.box.hasAttribute('data-text-required') && 'text' in x && !x.text; })[0];
      if (missing) {
        e.preventDefault();
        var mf = extraText(missing.box);
        if (mf) { mf.classList.add('is-invalid'); mf.focus(); }
        if (err) { err.textContent = tr('product.extras_text_missing', 'Please write the words for your choice above.'); err.hidden = false; }
        return;
      }
      if (!extras.length && (after === 'page' || after === 'no-js')) return; // plain submit
      e.preventDefault();
      var btn = form.querySelector('[data-ag-submit]');
      if (btn && (btn.disabled || btn.classList.contains('is-loading'))) return;
      if (err) { err.hidden = true; err.textContent = ''; }
      if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var ref = null;
      if (extras.length) {
        ref = 'L' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
        refInput = document.createElement('input');
        refInput.type = 'hidden'; refInput.name = 'properties[_ag_ref]'; refInput.value = ref;
        form.appendChild(refInput);
      }
      var post = function (url, body, json) {
        var h = { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
        if (json) h['Content-Type'] = 'application/json';
        return fetch(root + url, { method: 'POST', headers: h, body: json ? JSON.stringify(body) : body })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); });
      };
      post('cart/add.js', new FormData(form))
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || tr('cart.add_error', 'This icon could not be added to the cart.'));
          if (!extras.length) return res;
          var item = res.j.items ? res.j.items[0] : res.j;
          var forText = (item.product_title || '') + (item.variant_title ? ' — ' + item.variant_title : '');
          var items = extras.map(function (x) {
            var props = { For: forText, _ag_for: ref };
            if (x.text) props[x.prop || 'Text'] = x.text;
            var per = x.per || 1;
            if (per > 1) props._ag_per = String(per);
            return { id: parseInt(x.id, 10), quantity: (item.quantity || 1) * per, properties: props };
          });
          return post('cart/add.js', { items: items }, true)
            .then(function (r2) {
              if (r2.ok) { flag(true); return res; }
              // keep the cart honest: take the icon back out and explain
              return post('cart/change.js', { id: item.key, quantity: 0 }, true).then(function () {
                throw new Error(tr('cart.extras_error', 'The finishing touches could not be added just now. Please try again, or add the icon without them.'));
              });
            });
        })
        .then(function (res) {
          var t = btn && btn.querySelector('[data-ag-submit-text]');
          if (t) { var was = t.textContent; t.textContent = btn.getAttribute('data-text-added') || was; setTimeout(function () { t.textContent = was; }, 1800); }
          form.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: res.j.variant_id } }));
          if (after === 'page') { window.location.href = ((window.theme && window.theme.routes && window.theme.routes.cart) || root + 'cart'); return; }
          return refreshCart().then(function () { openCart(btn); });
        })
        .catch(function (ex) { if (err) { err.textContent = ex.message; err.hidden = false; } })
        .then(function () {
          if (refInput && refInput.parentNode) refInput.parentNode.removeChild(refInput);
          if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
        });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { syncPaidChoices(false); });
  else syncPaidChoices(false);

  /* ---------- Product page controls ---------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-ag-step]');
    if (step) {
      var gal = step.closest('[data-ag-gallery]');
      var thumbs = gal ? Array.prototype.slice.call(gal.querySelectorAll('[data-ag-thumb]')) : [];
      if (thumbs.length) {
        var cur = thumbs.findIndex(function (t) { return t.getAttribute('aria-current') === 'true'; });
        var next = thumbs[(Math.max(cur, 0) + parseInt(step.getAttribute('data-ag-step'), 10) + thumbs.length) % thumbs.length];
        showThumb(next);
        next.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
      return;
    }
    var qs = e.target.closest('[data-ag-qty-step]');
    if (qs) {
      var input = qs.closest('[data-ag-qty]').querySelector('input');
      var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(qs.getAttribute('data-ag-qty-step'), 10));
      input.value = v; input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var ch = e.target.closest('[data-ag-choice-value]');
    if (ch) {
      var box = ch.closest('[data-ag-choice]');
      Array.prototype.forEach.call(box.querySelectorAll('[data-ag-choice-value]'), function (b) { b.setAttribute('aria-checked', b === ch ? 'true' : 'false'); });
      var val = ch.getAttribute('data-ag-choice-value');
      box.querySelector('[data-ag-choice-input]').value = val;
      var lab = box.querySelector('[data-ag-choice-label]'); if (lab) lab.textContent = val;
      updateAddonUI(box.closest('form'));
      var rv = box.querySelector('[data-ag-reveal-box]');
      if (rv) {
        var show = ch.hasAttribute('data-ag-reveal');
        rv.hidden = !show;
        var field = rv.querySelector('input'); field.disabled = !show;
        if (show) field.focus();
      }
      return;
    }
    var tab = e.target.closest('[data-ag-tabs] [role="tab"]');
    if (tab) { selectTab(tab); }
  });
  function selectTab(tab) {
    var wrap = tab.closest('[data-ag-tabs]');
    Array.prototype.forEach.call(wrap.querySelectorAll('[role="tab"]'), function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      if (on) t.removeAttribute('tabindex'); else t.setAttribute('tabindex', '-1');
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
    });
  }
  /* A link such as "Size guide" opens a named tab in "About the icon" and scrolls to it */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-ag-open-tab]');
    if (!link) return;
    var tab = document.querySelector('[data-ag-tabs] [data-ag-tab-key="' + link.getAttribute('data-ag-open-tab') + '"]');
    if (!tab) return;
    e.preventDefault();
    selectTab(tab);
    var box = tab.closest('[data-ag-tabs]');
    tab.scrollIntoView({ block: 'nearest', inline: 'center' });
    var top = box.getBoundingClientRect().top + window.pageYOffset - 120;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  });
  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest && e.target.closest('[data-ag-tabs] [role="tab"]');
    if (!tab || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    var tabs = Array.prototype.slice.call(tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]'));
    var i = tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
    var n = tabs[(i + tabs.length) % tabs.length];
    selectTab(n); n.focus(); e.preventDefault();
  });

  /* ---------- G: Combined Listings (Grouptify): linked products as chips ----------
     The app loads window.mpg.group (options + products of the group this product
     belongs to). Its own widget only attaches to Symmetry's old variant picker, so
     on the AG product page we draw the same choices here and link to each product. */
  function initGroup(el) {
    if (el.getAttribute('data-ag-ready')) return;
    el.setAttribute('data-ag-ready', '1');
    var tries = 0;
    (function wait() {
      var g = window.mpg && window.mpg.group;
      if (g && g.products && g.options) { renderGroup(el, g); return; }
      if (++tries < 48) setTimeout(wait, 250);
    })();
  }
  function renderGroup(el, g) {
    if (g.is_active === false || g.show_on_prod === false) return;
    var section = el.closest('section') || document;
    if (section.querySelector('.mpg-swatch')) return;
    var pid = el.getAttribute('data-product-id');
    var handle = el.getAttribute('data-handle');
    var live = g.products.filter(function (p) { return !p.status || String(p.status).toUpperCase() === 'ACTIVE'; });
    var me = live.filter(function (p) { return String(p.id) === pid || p.handle === handle; })[0];
    if (!me || live.length < 2) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function sized(u) { return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=96'; }
    var html = '';
    var chosen = g.options.map(function (opt, i) {
      var n = '';
      (opt.values || []).forEach(function (v) { if (v.id === me.options[i]) n = v.name; });
      return n;
    });
    g.options.forEach(function (opt, i) {
      var cur = me.options[i];
      var firstName = chosen.slice(0, i).filter(Boolean).join(' · ');
      /* Later options depend on the choices above them: a value with no product that
         keeps the current earlier choices is faded (still links to its nearest product). */
      var picks = (opt.values || []).map(function (v) {
        var withV = live.filter(function (p) { return p.options[i] === v.id; });
        var same = withV.filter(function (p) { return p.options.every(function (o, k) { return k === i || o === me.options[k]; }); })[0];
        var above = withV.filter(function (p) { return p.options.every(function (o, k) { return k >= i || o === me.options[k]; }); });
        var pick = same || above[0] || withV[0];
        return pick ? { v: v, p: pick, off: i > 0 && !above.length } : null;
      }).filter(Boolean);
      if (picks.length < 2) return;
      var curName = '';
      opt.values.forEach(function (v) { if (v.id === cur) curName = v.name; });
      var swatch = /swatch/.test(opt.template_prod || '');
      html += '<div class="ag-pw__fs" role="group" aria-label="' + esc(opt.name) + '">' +
        '<p class="ag-pw__lg">' + esc(opt.name) + ': <span>' + esc(curName) + '</span></p><div class="ag-pw__chips">';
      picks.forEach(function (x) {
        var on = x.v.id === cur;
        var img = swatch ? (x.v.image_custom || x.v.image || x.p.variant_image || (x.p.images || [])[0] || '') : '';
        var inner = (img ? '<img src="' + esc(sized(img)) + '" alt="" width="36" height="36" loading="lazy">' : '') + '<span>' + esc(x.v.name) + '</span>';
        var cls = 'ag-pw__chip ag-pw__link' + (img ? ' ag-pw__link--sw' : '') + (x.p.available === false ? ' is-soldout' : '') + (x.off ? ' is-off' : '');
        var note = x.off ? ' title="' + esc('Not available with ' + firstName) + '"' : '';
        html += on
          ? '<span class="' + cls + '" aria-current="true">' + inner + '</span>'
          : '<a class="' + cls + '" href="' + root + 'products/' + encodeURIComponent(x.p.handle) + '"' + note + '>' + inner + (x.off ? '<span class="ag-sr"> (not available with ' + esc(firstName) + ')</span>' : '') + '</a>';
      });
      html += '</div></div>';
    });
    if (!html) return;
    el.innerHTML = html;
    el.hidden = false;
  }

  /* ---------- AR: a true-size 3D panel built in the browser from the product photo ---------- */
  var AR = (function () {
    var CRC_TABLE = null;
    function crc32(bytes) {
      if (!CRC_TABLE) {
        CRC_TABLE = new Uint32Array(256);
        for (var n = 0; n < 256; n++) {
          var c = n;
          for (var k = 0; k < 8; k++) c = c & 1 ? 0xEDB88320 ^ (c >>> 1) : c >>> 1;
          CRC_TABLE[n] = c >>> 0;
        }
      }
      var crc = 0xFFFFFFFF;
      for (var i = 0; i < bytes.length; i++) crc = CRC_TABLE[(crc ^ bytes[i]) & 0xFF] ^ (crc >>> 8);
      return (crc ^ 0xFFFFFFFF) >>> 0;
    }
    function utf8(s) { return new TextEncoder().encode(s); }

    /* The six faces of the panel: front (+Z, carries the photo), back, right, left, top, bottom.
       Each face: 4 corners, counter-clockwise seen from outside, and its outward normal. */
    function faces(w, h, d) {
      var x = w / 2, y = h / 2, z = d / 2;
      return [
        { n: [0, 0, 1], p: [[-x, -y, z], [x, -y, z], [x, y, z], [-x, y, z]] },
        { n: [0, 0, -1], p: [[x, -y, -z], [-x, -y, -z], [-x, y, -z], [x, y, -z]] },
        { n: [1, 0, 0], p: [[x, -y, z], [x, -y, -z], [x, y, -z], [x, y, z]] },
        { n: [-1, 0, 0], p: [[-x, -y, -z], [-x, -y, z], [-x, y, z], [-x, y, -z]] },
        { n: [0, 1, 0], p: [[-x, y, z], [x, y, z], [x, y, -z], [-x, y, -z]] },
        { n: [0, -1, 0], p: [[-x, -y, -z], [x, -y, -z], [x, -y, z], [-x, -y, z]] }
      ];
    }

    /* glTF 2.0 binary (.glb) for model-viewer (3D preview, and AR on Android) */
    function buildGLB(o) {
      var F = faces(o.w, o.h, o.d);
      var pos = [], nor = [], uv = [];
      F.forEach(function (f, fi) {
        f.p.forEach(function (p, i) {
          pos.push(p[0], p[1], p[2]);
          nor.push(f.n[0], f.n[1], f.n[2]);
          // photo on the front face; image top-left is (0,0) in glTF
          if (fi === 0) uv.push([0, 1, 1, 0][i], [1, 1, 0, 0][i]); else uv.push(0, 0);
        });
      });
      var idxFront = [0, 1, 2, 0, 2, 3], idxBody = [];
      for (var f = 1; f < 6; f++) { var b = f * 4; idxBody.push(b, b + 1, b + 2, b, b + 2, b + 3); }

      var parts = [], offset = 0, views = [];
      function add(bytes, target) {
        var pad = (4 - (offset % 4)) % 4;
        if (pad) { parts.push(new Uint8Array(pad)); offset += pad; }
        var v = { buffer: 0, byteOffset: offset, byteLength: bytes.byteLength };
        if (target) v.target = target;
        views.push(v); parts.push(new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength)); offset += bytes.byteLength;
        return views.length - 1;
      }
      var vPos = add(new Float32Array(pos), 34962), vNor = add(new Float32Array(nor), 34962), vUv = add(new Float32Array(uv), 34962);
      var vIf = add(new Uint16Array(idxFront), 34963), vIb = add(new Uint16Array(idxBody), 34963);
      var vImg = add(o.jpeg);
      var tail = (4 - (offset % 4)) % 4;
      if (tail) { parts.push(new Uint8Array(tail)); offset += tail; }

      var x = o.w / 2, y = o.h / 2, z = o.d / 2;
      var gltf = {
        asset: { version: '2.0', generator: 'Agiografia AR' },
        scene: 0, scenes: [{ nodes: [0] }], nodes: [{ mesh: 0, name: 'Icon' }],
        meshes: [{ primitives: [
          { attributes: { POSITION: 0, NORMAL: 1, TEXCOORD_0: 2 }, indices: 3, material: 0 },
          { attributes: { POSITION: 0, NORMAL: 1, TEXCOORD_0: 2 }, indices: 4, material: 1 }
        ] }],
        materials: [
          { name: 'Front', pbrMetallicRoughness: { baseColorTexture: { index: 0 }, metallicFactor: 0, roughnessFactor: 0.6 } },
          { name: 'Edge', pbrMetallicRoughness: { baseColorFactor: [o.edge[0], o.edge[1], o.edge[2], 1], metallicFactor: 0, roughnessFactor: 0.75 } }
        ],
        textures: [{ source: 0, sampler: 0 }],
        samplers: [{ magFilter: 9729, minFilter: 9987, wrapS: 33071, wrapT: 33071 }],
        images: [{ bufferView: vImg, mimeType: 'image/jpeg' }],
        accessors: [
          { bufferView: vPos, componentType: 5126, count: 24, type: 'VEC3', min: [-x, -y, -z], max: [x, y, z] },
          { bufferView: vNor, componentType: 5126, count: 24, type: 'VEC3' },
          { bufferView: vUv, componentType: 5126, count: 24, type: 'VEC2' },
          { bufferView: vIf, componentType: 5123, count: 6, type: 'SCALAR' },
          { bufferView: vIb, componentType: 5123, count: 30, type: 'SCALAR' }
        ],
        bufferViews: views,
        buffers: [{ byteLength: offset }]
      };
      var json = utf8(JSON.stringify(gltf));
      var jpad = (4 - (json.length % 4)) % 4;
      var jsonLen = json.length + jpad;
      var total = 12 + 8 + jsonLen + 8 + offset;
      var out = new Uint8Array(total), dv = new DataView(out.buffer), p = 0;
      dv.setUint32(0, 0x46546C67, true); dv.setUint32(4, 2, true); dv.setUint32(8, total, true); p = 12;
      dv.setUint32(p, jsonLen, true); dv.setUint32(p + 4, 0x4E4F534A, true); p += 8;
      out.set(json, p); for (var j = 0; j < jpad; j++) out[p + json.length + j] = 0x20; p += jsonLen;
      dv.setUint32(p, offset, true); dv.setUint32(p + 4, 0x004E4942, true); p += 8;
      parts.forEach(function (a) { out.set(a, p); p += a.length; });
      return out;
    }

    /* USDZ for iPhone / iPad (AR Quick Look), anchored to a wall */
    function buildUSDA(o) {
      var F = faces(o.w, o.h, o.d);
      function f3(v) { return '(' + v.map(function (n) { return +n.toFixed(5); }).join(', ') + ')'; }
      /* On a wall anchor, AR Quick Look points the model's +Y out of the wall, so the panel is
         laid flat: front face up (+Y), top of the icon towards -Z (up the wall). */
      function R(v) { return [v[0], v[2], -v[1]]; }
      F = F.map(function (f) { return { n: R(f.n), p: f.p.map(R) }; });
      function ext(list) {
        var lo = [1e9, 1e9, 1e9], hi = [-1e9, -1e9, -1e9];
        list.forEach(function (f) { f.p.forEach(function (q) { for (var k = 0; k < 3; k++) { lo[k] = Math.min(lo[k], q[k]); hi[k] = Math.max(hi[k], q[k]); } }); });
        return '[' + f3(lo) + ', ' + f3(hi) + ']';
      }
      var front = F[0], body = F.slice(1);
      var bodyPts = [], bodyNor = [], bodyIdx = [];
      body.forEach(function (f, i) { f.p.forEach(function (p) { bodyPts.push(f3(p)); bodyNor.push(f3(f.n)); }); bodyIdx.push(i * 4, i * 4 + 1, i * 4 + 2, i * 4 + 3); });
      var e = o.edge.map(function (n) { return +n.toFixed(4); }).join(', ');
      return [
        '#usda 1.0',
        '(',
        '    defaultPrim = "Root"',
        '    metersPerUnit = 1',
        '    upAxis = "Y"',
        ')',
        '',
        'def Xform "Root" (',
        '    prepend apiSchemas = ["Preliminary_AnchoringAPI"]',
        ')',
        '{',
        '    uniform token preliminary:anchoring:type = "plane"',
        '    uniform token preliminary:planeAnchoring:alignment = "vertical"',
        '',
        '    def Mesh "Front" (',
        '        prepend apiSchemas = ["MaterialBindingAPI"]',
        '    )',
        '    {',
        '        float3[] extent = ' + ext([front]),
        '        int[] faceVertexCounts = [4]',
        '        int[] faceVertexIndices = [0, 1, 2, 3]',
        '        rel material:binding = </Root/Materials/Front>',
        '        normal3f[] normals = [' + front.p.map(function () { return f3(front.n); }).join(', ') + '] (',
        '            interpolation = "vertex"',
        '        )',
        '        point3f[] points = [' + front.p.map(f3).join(', ') + ']',
        '        texCoord2f[] primvars:st = [(0, 0), (1, 0), (1, 1), (0, 1)] (',
        '            interpolation = "vertex"',
        '        )',
        '        uniform token subdivisionScheme = "none"',
        '    }',
        '',
        '    def Mesh "Body" (',
        '        prepend apiSchemas = ["MaterialBindingAPI"]',
        '    )',
        '    {',
        '        float3[] extent = ' + ext(F),
        '        int[] faceVertexCounts = [4, 4, 4, 4, 4]',
        '        int[] faceVertexIndices = [' + bodyIdx.join(', ') + ']',
        '        rel material:binding = </Root/Materials/Edge>',
        '        normal3f[] normals = [' + bodyNor.join(', ') + '] (',
        '            interpolation = "vertex"',
        '        )',
        '        point3f[] points = [' + bodyPts.join(', ') + ']',
        '        uniform token subdivisionScheme = "none"',
        '    }',
        '',
        '    def Scope "Materials"',
        '    {',
        '        def Material "Front"',
        '        {',
        '            token outputs:surface.connect = </Root/Materials/Front/Surface.outputs:surface>',
        '',
        '            def Shader "Surface"',
        '            {',
        '                uniform token info:id = "UsdPreviewSurface"',
        '                color3f inputs:diffuseColor.connect = </Root/Materials/Front/Photo.outputs:rgb>',
        '                float inputs:metallic = 0',
        '                float inputs:roughness = 0.6',
        '                token outputs:surface',
        '            }',
        '',
        '            def Shader "Uv"',
        '            {',
        '                uniform token info:id = "UsdPrimvarReader_float2"',
        '                string inputs:varname = "st"',
        '                float2 outputs:result',
        '            }',
        '',
        '            def Shader "Photo"',
        '            {',
        '                uniform token info:id = "UsdUVTexture"',
        '                asset inputs:file = @photo.jpg@',
        '                float2 inputs:st.connect = </Root/Materials/Front/Uv.outputs:result>',
        '                token inputs:wrapS = "clamp"',
        '                token inputs:wrapT = "clamp"',
        '                token inputs:sourceColorSpace = "sRGB"',
        '                float3 outputs:rgb',
        '            }',
        '        }',
        '',
        '        def Material "Edge"',
        '        {',
        '            token outputs:surface.connect = </Root/Materials/Edge/Surface.outputs:surface>',
        '',
        '            def Shader "Surface"',
        '            {',
        '                uniform token info:id = "UsdPreviewSurface"',
        '                color3f inputs:diffuseColor = (' + e + ')',
        '                float inputs:metallic = 0',
        '                float inputs:roughness = 0.75',
        '                token outputs:surface',
        '            }',
        '        }',
        '    }',
        '}',
        ''
      ].join('\n');
    }

    /* Uncompressed zip with every file's data on a 64-byte boundary, as USDZ requires */
    function zipStore(files) {
      var chunks = [], central = [], offset = 0;
      files.forEach(function (f) {
        var name = utf8(f.name), data = f.data, crc = crc32(data);
        var base = offset + 30 + name.length;
        var extra = (64 - ((base + 4) % 64)) % 64 + 4; // one extra field: 4-byte header + padding
        var lh = new Uint8Array(30 + name.length + extra), dv = new DataView(lh.buffer);
        dv.setUint32(0, 0x04034B50, true); dv.setUint16(4, 20, true); dv.setUint16(6, 0, true); dv.setUint16(8, 0, true);
        dv.setUint16(10, 0, true); dv.setUint16(12, 0x21, true); dv.setUint32(14, crc, true);
        dv.setUint32(18, data.length, true); dv.setUint32(22, data.length, true);
        dv.setUint16(26, name.length, true); dv.setUint16(28, extra, true);
        lh.set(name, 30);
        dv.setUint16(30 + name.length, 0x1986, true); dv.setUint16(32 + name.length, extra - 4, true);
        chunks.push(lh, data);
        central.push({ name: name, crc: crc, size: data.length, offset: offset });
        offset += lh.length + data.length;
      });
      var cdStart = offset, cdChunks = [];
      central.forEach(function (c) {
        var h = new Uint8Array(46 + c.name.length), dv = new DataView(h.buffer);
        dv.setUint32(0, 0x02014B50, true); dv.setUint16(4, 20, true); dv.setUint16(6, 20, true);
        dv.setUint16(12, 0, true); dv.setUint16(14, 0x21, true); dv.setUint32(16, c.crc, true);
        dv.setUint32(20, c.size, true); dv.setUint32(24, c.size, true); dv.setUint16(28, c.name.length, true);
        dv.setUint32(42, c.offset, true); h.set(c.name, 46);
        cdChunks.push(h); offset += h.length;
      });
      var end = new Uint8Array(22), edv = new DataView(end.buffer);
      edv.setUint32(0, 0x06054B50, true); edv.setUint16(8, files.length, true); edv.setUint16(10, files.length, true);
      edv.setUint32(12, offset - cdStart, true); edv.setUint32(16, cdStart, true);
      var all = chunks.concat(cdChunks, [end]), size = 0;
      all.forEach(function (a) { size += a.length; });
      var out = new Uint8Array(size), p = 0;
      all.forEach(function (a) { out.set(a, p); p += a.length; });
      return out;
    }
    function buildUSDZ(o) {
      return zipStore([{ name: 'icon.usda', data: utf8(buildUSDA(o)) }, { name: 'photo.jpg', data: o.jpeg }]);
    }

    return { buildGLB: buildGLB, buildUSDZ: buildUSDZ, buildUSDA: buildUSDA };
  })();

  /* "View on your wall": opens a viewer with the icon at the chosen size. Phones place it on a
     real wall (iPhone/iPad: AR Quick Look; Android: Chrome WebXR); computers show a QR code. */
  /* The viewer (<model-viewer> + QR code) lives in the theme as assets/ag-3d.js and loads only
     when someone opens it; a public CDN is the fallback. */
  var AR_CDN = 'https://cdn.jsdelivr.net/npm/@google/model-viewer@4.1.0/dist/model-viewer.min.js';
  var QR_CDN = 'https://cdn.jsdelivr.net/npm/qrcode-generator@1.4.4/qrcode.js';
  var arScripts = {};
  function arEsc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function loadScript(src, isModule) {
    if (arScripts[src]) return arScripts[src];
    arScripts[src] = new Promise(function (res, rej) {
      var s = document.createElement('script');
      if (isModule) s.type = 'module';
      s.src = src; s.async = true;
      s.onload = res; s.onerror = function () { delete arScripts[src]; rej(new Error('load ' + src)); };
      document.head.appendChild(s);
    });
    return arScripts[src];
  }
  function withTimeout(p, ms) {
    return new Promise(function (res, rej) {
      var t = setTimeout(function () { rej(new Error('timeout')); }, ms);
      p.then(function (v) { clearTimeout(t); res(v); }, function (e) { clearTimeout(t); rej(e); });
    });
  }
  function viewerDefined() {
    return withTimeout(customElements.whenDefined('model-viewer'), 12000);
  }
  function loadViewer(lib) {
    if (window.customElements && customElements.get('model-viewer') && window.qrcode) return Promise.resolve();
    var first = lib ? loadScript(lib, true).then(viewerDefined) : Promise.reject(new Error('no lib'));
    return first.catch(function () {
      return loadScript(AR_CDN, true).then(viewerDefined);
    });
  }
  function loadQR(lib) {
    if (window.qrcode) return Promise.resolve();
    return withTimeout(loadViewer(lib), 20000).then(function () {
      return window.qrcode ? null : loadScript(QR_CDN);
    });
  }
  function toLinear(c) { c /= 255; return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); }

  /* Cut the icon out of its product photo (transparent or plain background), note its edge colour */
  function cutPhoto(img) {
    var W = img.naturalWidth, H = img.naturalHeight;
    var c = document.createElement('canvas'); c.width = W; c.height = H;
    var g = c.getContext('2d', { willReadFrequently: true });
    g.drawImage(img, 0, 0);
    var d = g.getImageData(0, 0, W, H).data;
    var b0 = d[0], b1 = d[1], b2 = d[2], bOpaque = d[3] >= 200;
    function bg(i) {
      if (d[i + 3] < 200) return true;
      return bOpaque && Math.abs(d[i] - b0) + Math.abs(d[i + 1] - b1) + Math.abs(d[i + 2] - b2) < 30;
    }
    var x0 = W, y0 = H, x1 = -1, y1 = -1, x, y;
    for (y = 0; y < H; y++) for (x = 0; x < W; x++) {
      if (!bg((y * W + x) * 4)) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
    }
    if (x1 < x0 || y1 < y0 || (x1 - x0) < W * 0.2 || (y1 - y0) < H * 0.2) { x0 = 0; y0 = 0; x1 = W - 1; y1 = H - 1; }
    var cw = x1 - x0 + 1, ch = y1 - y0 + 1;
    var inset = Math.round(Math.min(cw, ch) * 0.004);
    x0 += inset; y0 += inset; cw -= inset * 2; ch -= inset * 2;
    // edge colour: the outer band of the panel
    var band = Math.max(2, Math.round(Math.min(cw, ch) * 0.02)), r = 0, gg = 0, bb = 0, n = 0;
    for (y = y0; y < y0 + ch; y += 2) for (x = x0; x < x0 + cw; x += 2) {
      if (x - x0 > band && x0 + cw - x > band && y - y0 > band && y0 + ch - y > band) continue;
      var i = (y * W + x) * 4; if (d[i + 3] < 200) continue;
      r += d[i]; gg += d[i + 1]; bb += d[i + 2]; n++;
    }
    var edge = n ? [toLinear(r / n * 0.8), toLinear(gg / n * 0.8), toLinear(bb / n * 0.8)] : [0.3, 0.05, 0.04];
    var t = document.createElement('canvas'); t.width = 1024; t.height = 1024;
    var tg = t.getContext('2d');
    tg.fillStyle = 'rgb(' + Math.round(r / (n || 1)) + ',' + Math.round(gg / (n || 1)) + ',' + Math.round(bb / (n || 1)) + ')';
    tg.fillRect(0, 0, 1024, 1024);
    tg.drawImage(c, x0, y0, cw, ch, 0, 0, 1024, 1024);
    return new Promise(function (res) {
      t.toBlob(function (blob) {
        blob.arrayBuffer().then(function (buf) { res({ jpeg: new Uint8Array(buf), edge: edge, aspect: cw / ch }); });
      }, 'image/jpeg', 0.86);
    });
  }

  function initAR(box) {
    if (box.__agAR) return; box.__agAR = true;
    var openBtn = box.querySelector('[data-ag-ar-open]');
    var card = document.querySelector('[data-ag-picker]');
    var ua = navigator.userAgent || '';
    var probe = document.createElement('a');
    var appleTouch = /iPhone|iPad|iPod/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    // Only Safari opens AR Quick Look from a file made on the page. Other iPhone browsers (Firefox, Chrome,
    // Edge, in-app browsers) just download it, so they get a button that reopens this page in Safari instead.
    var quickLook = !!(probe.relList && probe.relList.supports && probe.relList.supports('ar'));
    var isIOS = quickLook || appleTouch;
    var needSafari = appleTouch && !quickLook;
    var isAndroid = /Android/i.test(ua);
    var onPhone = isIOS || isAndroid || (window.matchMedia && matchMedia('(pointer: coarse)').matches && Math.min(screen.width, screen.height) < 820);
    var depth = (parseFloat(box.getAttribute('data-depth')) || 20) / 1000;
    var photo = null, cache = {}, modal = null;

    function currentSize() {
      var on = card && card.querySelector('.ag-pw__sizes [aria-checked="true"]');
      var txt = on ? on.getAttribute('data-value') : (box.getAttribute('data-size') || '');
      var m = (txt || '').match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*cm/i);
      if (!m) return null;
      var label = m[1] + ' × ' + m[2] + ' cm';
      /* Inch countries: the wall view names the size in inches */
      var inch = card && card.hasAttribute('data-ag-inch-first') && (txt || '').match(/\(([^)]*\bin)\)/);
      if (inch) label = inch[1].replace(/ x /g, ' × ');
      return { a: parseFloat(m[1].replace(',', '.')), b: parseFloat(m[2].replace(',', '.')), label: label };
    }
    if (!currentSize()) { box.hidden = true; return; }

    function loadPhoto() {
      if (photo) return photo;
      photo = new Promise(function (res, rej) {
        var img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function () { cutPhoto(img).then(res, rej); };
        img.onerror = rej;
        img.src = box.getAttribute('data-img');
      });
      photo.catch(function () { photo = null; });
      return photo;
    }
    function build(size) {
      return loadPhoto().then(function (ph) {
        var a = size.a / 100, b = size.b / 100, w = a, h = b;
        if ((ph.aspect >= 1) !== (a >= b)) { w = b; h = a; } // follow the photo's orientation
        var key = w + 'x' + h;
        if (cache[key]) return cache[key];
        var o = { w: w, h: h, d: depth, jpeg: ph.jpeg, edge: ph.edge };
        var out = { glb: URL.createObjectURL(new Blob([AR.buildGLB(o)], { type: 'model/gltf-binary' })) };
        if (isIOS && !needSafari) out.usdz = URL.createObjectURL(new Blob([AR.buildUSDZ(o)], { type: 'model/vnd.usdz+zip' }));
        return (cache[key] = out);
      });
    }

    function makeModal() {
      var t = function (k, f) { return box.getAttribute('data-t-' + k) || f; };
      var m = document.createElement('div');
      m.className = 'ag-s ag-arm';
      m.setAttribute('role', 'dialog'); m.setAttribute('aria-modal', 'true'); m.setAttribute('aria-labelledby', 'AgArTitle');
      m.hidden = true;
      m.innerHTML =
        '<div class="ag-arm__in">' +
          '<button type="button" class="ag-arm__x" data-ag-ar-close aria-label="Close">×</button>' +
          '<div class="ag-arm__view"><p class="ag-arm__wait" data-ag-ar-wait>' + arEsc(t('wait', 'Preparing the icon…')) + '</p></div>' +
          '<div class="ag-arm__side">' +
            '<p class="ag-eb">' + arEsc(t('eyebrow', 'On your wall')) + '</p>' +
            '<h2 class="ag-arm__t" id="AgArTitle">' + arEsc(box.getAttribute('data-title') || '') + '</h2>' +
            '<p class="ag-arm__size" data-ag-ar-size></p>' +
            (needSafari
              ? '<a class="ag-arm__go" href="' + arEsc('x-safari-' + location.href.split('#')[0] + '#ar') + '"><img src="' + arEsc(box.getAttribute('data-thumb') || '') + '" alt="" width="40" height="40"><span>' + arEsc(t('safari', 'Open in Safari to place it on your wall')) + '</span></a>' +
                '<p class="ag-arm__hint">' + arEsc(t('safari-hint', 'This browser can only download the 3D file. Safari shows the icon on your wall at its real size; the button opens this page there.')) + '</p>'
              : onPhone
              ? '<a class="ag-arm__go" data-ag-ar-go href="#" ' + (isIOS ? 'rel="ar"' : 'role="button"') + ' aria-disabled="true"><img src="' + arEsc(box.getAttribute('data-thumb') || '') + '" alt="" width="40" height="40"><span>' + arEsc(t('go', 'Place it on my wall')) + '</span></a>' +
                '<p class="ag-arm__hint">' + arEsc(t('hint', 'Point your camera at a wall and move it slowly until the icon appears. It stays at its real size.')) + '</p>' +
                '<p class="ag-arm__hint" data-ag-ar-nope hidden>' + arEsc(t('nope', 'This browser cannot open AR. On Android use Chrome; on iPhone or iPad use Safari.')) + '</p>'
              : '<div class="ag-arm__qr" data-ag-ar-qr></div>' +
                '<p class="ag-arm__hint">' + arEsc(t('qr', 'Scan with your phone camera to see this icon on your own wall, at its real size.')) + '</p>') +
          '</div>' +
        '</div>';
      document.body.appendChild(m);
      m.addEventListener('click', function (e) {
        if (e.target === m || e.target.closest('[data-ag-ar-close]')) close();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !m.hidden) close(); });
      var go = m.querySelector('[data-ag-ar-go]');
      if (go && isAndroid) go.addEventListener('click', function (e) {
        e.preventDefault();
        var mv = m.querySelector('model-viewer');
        if (mv && mv.canActivateAR) mv.activateAR();
        else m.querySelector('[data-ag-ar-nope]').hidden = false;
      });
      if (go && isIOS) go.addEventListener('click', function (e) { if (go.getAttribute('aria-disabled') === 'true') e.preventDefault(); });
      if (go && !isIOS && !isAndroid) go.addEventListener('click', function (e) { e.preventDefault(); m.querySelector('[data-ag-ar-nope]').hidden = false; });
      return m;
    }
    function close() {
      modal.hidden = true;
      document.documentElement.classList.remove('ag-arm-on');
      if (openBtn) openBtn.focus();
    }
    function open() {
      var size = currentSize();
      if (!size) return;
      if (!modal) modal = makeModal();
      modal.hidden = false;
      document.documentElement.classList.add('ag-arm-on');
      modal.querySelector('[data-ag-ar-size]').textContent = size.label + ' · ' + (box.getAttribute('data-t-scale') || 'true to scale');
      var wait = modal.querySelector('[data-ag-ar-wait]');
      wait.hidden = false; wait.textContent = box.getAttribute('data-t-wait') || 'Preparing the icon…';
      var go = modal.querySelector('[data-ag-ar-go]');
      if (go) go.setAttribute('aria-disabled', 'true');
      modal.querySelector('.ag-arm__x').focus();
      function fail() {
        wait.hidden = false;
        wait.textContent = box.getAttribute('data-t-fail') || 'Sorry, the 3D view could not load. Please refresh the page and try again.';
      }

      var qr = modal.querySelector('[data-ag-ar-qr]');
      if (qr) {
        loadQR(box.getAttribute('data-lib')).then(function () {
          // a clean link to this product and size only (no preview or tracking parameters)
          var idInput = card && card.querySelector('input[name="id"]');
          var link = location.origin + location.pathname + (idInput && idInput.value ? '?variant=' + idInput.value : '') + '#ar';
          var q = window.qrcode(0, 'M'); q.addData(link); q.make();
          qr.innerHTML = q.createSvgTag({ cellSize: 4, margin: 2, scalable: true, alt: 'QR code: open this page on your phone' });
        }).catch(function () { qr.hidden = true; });
      }

      withTimeout(Promise.all([build(size), loadViewer(box.getAttribute('data-lib'))]), 25000).then(function (r) {
        var files = r[0];
        var view = modal.querySelector('.ag-arm__view');
        var mv = view.querySelector('model-viewer');
        if (!mv) {
          mv = document.createElement('model-viewer');
          mv.setAttribute('camera-controls', '');
          mv.setAttribute('interaction-prompt', 'none');
          mv.setAttribute('shadow-intensity', '1');
          mv.setAttribute('tone-mapping', 'neutral');
          mv.setAttribute('camera-orbit', '18deg 82deg auto');
          mv.setAttribute('alt', box.getAttribute('data-title') || '');
          if (isAndroid) {
            mv.setAttribute('ar', '');
            mv.setAttribute('ar-modes', 'webxr');
            mv.setAttribute('ar-placement', 'wall');
            mv.setAttribute('ar-scale', 'fixed');
            var hidden = document.createElement('span'); hidden.slot = 'ar-button'; hidden.style.display = 'none';
            mv.appendChild(hidden);
          }
          view.appendChild(mv);
        }
        var ready = function () { wait.hidden = true; if (go) go.setAttribute('aria-disabled', 'false'); };
        if (mv.getAttribute('src') === files.glb && mv.loaded) ready();
        else {
          mv.addEventListener('load', ready, { once: true });
          mv.addEventListener('error', fail, { once: true });
          mv.setAttribute('src', files.glb);
        }
        if (go && isIOS && !needSafari) { go.setAttribute('href', files.usdz + '#allowsContentScaling=0'); go.setAttribute('download', 'icon.usdz'); }
      }).catch(fail);
    }

    if (openBtn) openBtn.addEventListener('click', open);
    if (location.hash === '#ar') setTimeout(open, 600);
  }

  /* ---------- Questions page: topic links and a search that filters the answers ---------- */
  function initFaq(head) {
    if (head.__agFaq) return; head.__agFaq = true;
    var groups = Array.prototype.slice.call(document.querySelectorAll('[data-ag-faq-group]'));
    var index = head.querySelector('[data-ag-faq-index]');
    if (index && !index.children.length) {
      groups.forEach(function (g) {
        var t = g.querySelector('[data-ag-faq-title]');
        if (!t || !g.id) return;
        var a = document.createElement('a');
        a.href = '#' + g.id; a.textContent = t.textContent.trim();
        index.appendChild(a);
      });
      var wrap = head.querySelector('[data-ag-faq-index-wrap]');
      if (wrap) wrap.hidden = index.children.length < 2;
    }
    var input = head.querySelector('[data-ag-faq-search]');
    var none = head.querySelector('[data-ag-faq-none]');
    if (!input) return;
    var timer;
    function run() {
      var q = input.value.trim().toLowerCase(), hits = 0;
      groups.forEach(function (g) {
        var title = g.querySelector('[data-ag-faq-title]');
        var titleHit = q && title && title.textContent.toLowerCase().indexOf(q) > -1;
        var any = false;
        Array.prototype.forEach.call(g.querySelectorAll('details'), function (d) {
          var ok = !q || titleHit || d.textContent.toLowerCase().indexOf(q) > -1;
          d.hidden = !ok;
          if (q) d.open = ok && !titleHit; else d.open = false;
          if (ok) { any = true; hits++; }
        });
        g.hidden = !any;
      });
      if (none) none.hidden = !q || hits > 0;
    }
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 120); });
    input.addEventListener('search', run);
  }

  /* ---------- Chat button (Shopify Inbox) in the gallery style ---------- */
  // The Inbox button lives inside the app's own component; we add our styling to it once it appears.
  var CHAT_CSS = '.activator-nudge{right:var(--ag-wx,20px)!important;bottom:calc(var(--ag-dock,0px) + var(--ag-wy,20px))!important;width:var(--ag-wsz,44px)!important;height:var(--ag-wsz,44px)!important;transition:bottom .25s ease}' +
    '.activator{width:var(--ag-wsz,44px)!important;height:var(--ag-wsz,44px)!important;border-radius:50%!important;background:#171615!important;color:#F3EFE6!important;box-shadow:inset 0 0 0 3px #171615,inset 0 0 0 4px #B08A3E,0 6px 16px rgba(23,22,21,.28)!important}' +
    '.activator__icon{color:#F3EFE6!important}';
  function styleChat() {
    var host = document.querySelector('shopify-chat');
    if (!host || !host.shadowRoot) return false;
    var roots = [host.shadowRoot];
    Array.prototype.forEach.call(host.shadowRoot.querySelectorAll('*'), function (el) { if (el.shadowRoot) roots.push(el.shadowRoot); });
    var done = false;
    roots.forEach(function (r) {
      if (!r.querySelector('.activator')) return;
      if (!r.getElementById('ag-chat-style')) {
        var st = document.createElement('style');
        st.id = 'ag-chat-style';
        st.textContent = CHAT_CSS;
        r.appendChild(st);
      }
      done = true;
    });
    return done;
  }
  // Checked every 1.5 s, so the styling comes back if the app redraws its button.
  setInterval(styleChat, 1500);

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ag-sticky]'), initSticky);
    Array.prototype.forEach.call(suggestInputs(document), initSuggest);
    Array.prototype.forEach.call(document.querySelectorAll('[data-ag-voice]'), initVoice);
    Array.prototype.forEach.call(document.querySelectorAll('[data-ag-extras]'), initExtras);
    Array.prototype.forEach.call(document.querySelectorAll('[data-ag-group]'), initGroup);
    Array.prototype.forEach.call(document.querySelectorAll('[data-ag-picker]'), initPicker);
    Array.prototype.forEach.call(document.querySelectorAll('form[data-ag-filters]'), initFilters);
    Array.prototype.forEach.call(document.querySelectorAll('[data-ag-recs]'), initRecs);
    Array.prototype.forEach.call(document.querySelectorAll('[data-ag-paths]'), initPaths);
    Array.prototype.forEach.call(document.querySelectorAll('[data-ag-jm-clamp]'), initJmClamp);
    Array.prototype.forEach.call(document.querySelectorAll('[data-ag-saints]'), initSaints);
    Array.prototype.forEach.call(document.querySelectorAll('[data-ag-scroller]'), initScroller);
    Array.prototype.forEach.call(document.querySelectorAll('[data-ag-feast]'), initFeast);
    Array.prototype.forEach.call(document.querySelectorAll('[data-ag-opening]'), initOpening);
    Array.prototype.forEach.call(document.querySelectorAll('[data-ag-shuffle]'), initShuffle);
    Array.prototype.forEach.call(document.querySelectorAll('[data-ag-hang]'), initHang);
    Array.prototype.forEach.call(document.querySelectorAll('form[data-ag-ajax]'), initAjaxForm);
    Array.prototype.forEach.call(document.querySelectorAll('[data-ag-ar]'), initAR);
    Array.prototype.forEach.call(document.querySelectorAll('[data-ag-faq]'), initFaq);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Theme editor: re-run when a section is added or changed */
  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    Array.prototype.forEach.call(t.querySelectorAll('[data-ag-sticky]'), initSticky);
    Array.prototype.forEach.call(suggestInputs(t), initSuggest);
    Array.prototype.forEach.call(t.querySelectorAll('[data-ag-voice]'), initVoice);
    Array.prototype.forEach.call(t.querySelectorAll('[data-ag-extras]'), initExtras);
    Array.prototype.forEach.call(t.querySelectorAll('[data-ag-group]'), initGroup);
    Array.prototype.forEach.call(t.querySelectorAll('[data-ag-picker]'), initPicker);
    Array.prototype.forEach.call(t.querySelectorAll('form[data-ag-filters]'), initFilters);
    Array.prototype.forEach.call(t.querySelectorAll('[data-ag-recs]'), initRecs);
    Array.prototype.forEach.call(t.querySelectorAll('[data-ag-saints]'), initSaints);
    Array.prototype.forEach.call(t.querySelectorAll('[data-ag-scroller]'), initScroller);
    Array.prototype.forEach.call(t.querySelectorAll('[data-ag-feast]'), initFeast);
    Array.prototype.forEach.call(t.querySelectorAll('[data-ag-opening]'), initOpening);
    Array.prototype.forEach.call(t.querySelectorAll('[data-ag-shuffle]'), initShuffle);
    Array.prototype.forEach.call(t.querySelectorAll('[data-ag-hang]'), initHang);
    Array.prototype.forEach.call(t.querySelectorAll('form[data-ag-ajax]'), initAjaxForm);
    Array.prototype.forEach.call(t.querySelectorAll('[data-ag-ar]'), initAR);
    Array.prototype.forEach.call(t.querySelectorAll('[data-ag-faq]'), initFaq);
  });
})();
